import $ from 'jquery';

global.$ = global.jQuery = $;
export default () => {


  // Polyfills

  const _createClass = function () {
    function defineProperties(target, props) {
      for (let i = 0; i < props.length; i++) {
        const descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  (function ($) {
    const proxy = $.fn.serializeArray;
    $.fn.serializeArray = function () {
      const inputs = this.find(':disabled');
      inputs.prop('disabled', false);
      const serialized = proxy.apply(this, arguments);
      inputs.prop('disabled', true);
      return serialized;
    };
  })(jQuery);

  if (typeof Object.assign !== 'function') {
    Object.assign = function (target, varArgs) {
      // .length of function is 2



      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      const to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        const nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (const nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    };
  }

  if (!String.prototype.includes) {
    String.prototype.includes = function () {
      return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
  }

  if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
      value: function value(searchElement, fromIndex) {

        // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        const o = Object(this);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        const len = o.length >>> 0;

        // 3. If len is 0, return false.
        if (len === 0) {
          return false;
        }

        // 4. Let n be ? ToInteger(fromIndex).
        //    (If fromIndex is undefined, this step produces the value 0.)
        const n = fromIndex | 0;

        // 5. If n в‰Ґ 0, then
        //  a. Let k be n.
        // 6. Else n < 0,
        //  a. Let k be len + n.
        //  b. If k < 0, let k be 0.
        let k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        function sameValueZero(x, y) {
          return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
        }

        // 7. Repeat, while k < len
        while (k < len) {
          // a. Let elementK be the result of ? Get(O, ! ToString(k)).
          // b. If SameValueZero(searchElement, elementK) is true, return true.
          // c. Increase k by 1. 
          if (sameValueZero(o[k], searchElement)) {
            return true;
          }
          k++;
        }

        // 8. Return false
        return false;
      }
    });
  }

  Number.isInteger = Number.isInteger || function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

  // V

  const v_os = function v_os() {
    let a = 0;
    switch (navigator.userAgent.indexOf("Windows") != -1 && (a = 1), navigator.userAgent.indexOf("Linux") != -1 && (a = 2), navigator.userAgent.indexOf("Mac") != -1 && (a = 3), navigator.userAgent.indexOf("FreeBSD") != -1 && (a = 4), a) {
      case 1:
        return "windows";
      case 2:
        return "linux";
      case 3:
        return "macos";
      case 4:
        return "freebsd";
      default:
        return 'unknown';
    }
  };

  const v_browser = function v_browser() {
    if (v_browser.prototype._cachedResult) return v_browser.prototype._cachedResult;
    let a = !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0,
      b = typeof InstallTrigger !== "undefined",
      c = /constructor/i.test(window.HTMLElement) || function (a) {
        return a.toString() === "[object SafariRemoteNotification]";
      }(!window.safari || safari.pushNotification),
      d = !!document.documentMode,
      e = !d && !!window.StyleMedia,
      f = !!window.chrome && !!window.chrome.webstore;
    (f || a) && window.CSS;
    return v_browser.prototype._cachedResult = a ? "Opera" : b ? "Firefox" : c ? "Safari" : f ? "Chrome" : d ? "IE" : e ? "Edge" : "unknown";
  };

  const V = function () {
    function V() {
      const data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, V);

      // data - object
      this.time = new Date().getTime();
      this.init(data);
    }

    _createClass(V, [{
      key: 'consoleInfo',
      value: function consoleInfo(string) {
        // string - string
        if (this.properties.consoleInfo === true) {
          console.info(string);
        }
      }
    }, {
      key: 'consoleError',
      value: function consoleError(string) {
        // string - string
        if (this.properties.consoleError === true) {
          console.error(string);
        }
      }
    }, {
      key: 'init',
      value: function init() {

        this.properties = {
          consoleInfo: false, // bool
          consoleError: false, // bool
          page: 'home', // string
          template: 1, // int
          theme: 'light', // string
          mobile: 760, // int
          tablet: 1199 // int
        };

        let data = void 0;

        if (window.vProperties !== undefined) {
          data = window.vProperties;
        } else {
          data = {};
        }

        for (const value in data) {
          this.properties[value] = data[value];
        }

        // page
        const page = this.properties.page.split(" ");
        for (let i = 0; i < page.length; i++) {
          document.documentElement.classList.add(`v-page-${  page[i]}`);
        }

        // template
        document.documentElement.classList.add(`v-template-${  this.properties.template}`);

        // theme
        document.body.classList.add(`v-theme-${  this.properties.theme}`);

        // os
        this.os = v_os().toLowerCase();
        document.documentElement.classList.add(`v-os-${  this.os}`);
        this.consoleInfo(`OS Title: ${  this.os}`);

        // browser
        this.browser = v_browser().toLowerCase();
        document.documentElement.classList.add(`v-browser-${  this.browser}`);
        this.consoleInfo(`Browser Title: ${  this.browser}`);

        // breakpoints
        this.viewportWidth = [document.documentElement.clientWidth, document.documentElement.clientWidth]; // prev, new
        this.viewportHeight = [document.documentElement.clientHeight, document.documentElement.clientHeight]; // prev, new
        this.consoleInfo(`Viewport Width: ${  this.viewportWidth[1]  }. Viewport Height: ${  this.viewportHeight[1]}`);

        // resizing
        this.resizeArray = []; // ['w|h|wh', callback]
        window.addEventListener("resize", () => {
          this.viewportWidth[1] = document.documentElement.clientWidth;
          this.viewportHeight[1] = document.documentElement.clientHeight;
          for (let _i = 0; _i < this.resizeArray.length; _i++) {
            if (this.resizeArray[_i][0] == 'w') {
              if (this.viewportWidth[0] !== this.viewportWidth[1]) {
                this.resizeArray[_i][1]();
              }
            } else if (this.resizeArray[_i][0] == 'h') {
              if (this.viewportHeight[0] !== this.viewportHeight[1]) {
                this.resizeArray[_i][1]();
              }
            } else if (this.resizeArray[_i][0] == 'wh') {
              this.resizeArray[_i][1]();
            }
          }
          this.viewportWidth[0] = this.viewportWidth[1];
          this.viewportHeight[0] = this.viewportHeight[1];
          this.consoleInfo(`Viewport Has Been Resized. Viewport Width: ${  this.viewportWidth[1]  }. Viewport Height: ${  this.viewportHeight[1]}`);
          if (this.viewportWidth[1] <= this.properties.tablet) document.documentElement.classList.add("breakpoint-tablet");
          else document.documentElement.classList.remove("breakpoint-tablet");
          if (this.viewportWidth[1] <= this.properties.mobile) document.documentElement.classList.add("breakpoint-mobile");
          else document.documentElement.classList.remove("breakpoint-mobile");
        });
        if (this.viewportWidth[1] <= this.properties.tablet) document.documentElement.classList.add("breakpoint-tablet");
        else document.documentElement.classList.remove("breakpoint-tablet");
        if (this.viewportWidth[1] <= this.properties.mobile) document.documentElement.classList.add("breakpoint-mobile");
        else document.documentElement.classList.remove("breakpoint-mobile");

        // loading
        this.loadArray = [];
        window.addEventListener("load", () => {
          for (let _i2 = 0; _i2 < this.loadArray.length; _i2++) {
            this.loadArray[_i2]();
          }
          this.consoleInfo(`The Page Has Been Loaded For: ${  (new Date().getTime() - this.time) / 1000  }s`);
        });

        // time
        this.timeMin = 25;
        this.ajaxMaxTime = 1500;

        // url

        window.onpopstate = function (e) {
          if (e.state !== null) {
            location.reload();
          }
        };
      }

      // check page

    }, {
      key: 'checkPage',
      value: function checkPage() {
        const string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'home1';
        // string - string
        const page = this.properties.page.split(" ");
        for (let i = 0; i < page.length; i++) {
          if (string === page[i]) {
            return true;
          }
        }
        return false;
      }

      // random int

    }, {
      key: 'randInt',
      value: function randInt() {
        let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            min: 0,
            max: 100
          },
          min = _ref.min,
          max = _ref.max;

        // min, max - int
        let rand = min + Math.random() * (max - min);
        rand = Math.round(rand);
        return rand;
      }

      // get parameter

    }, {
      key: 'getParameter',
      value: function getParameter() {
        let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            name: 'name',
            url: window.location.href
          },
          _ref2$name = _ref2.name,
          name = _ref2$name === undefined ? 'name' : _ref2$name,
          _ref2$url = _ref2.url,
          url = _ref2$url === undefined ? window.location.href : _ref2$url;

        name = name.replace(/[\[\]]/g, "\\$&");
        let regex = new RegExp(`[?&]${  name  }(=([^&#]*)|&|#|$)`),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
      }

      // set parameter

    }, {
      key: 'setParameter',
      value: function setParameter() {
        let _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            name: 'name',
            value: 'value',
            push: false
          },
          _ref3$name = _ref3.name,
          name = _ref3$name === undefined ? 'name' : _ref3$name,
          _ref3$value = _ref3.value,
          value = _ref3$value === undefined ? 'value' : _ref3$value,
          _ref3$push = _ref3.push,
          push = _ref3$push === undefined ? true : _ref3$push;

        name = encodeURI(name);
        value = encodeURI(value);
        let kvp = document.location.search.substr(1) === "" ? [] : document.location.search.substr(1).split('&'),
          i = kvp.length,
          x = void 0;
        while (i--) {
          x = kvp[i].split('=');
          if (x[0] == name) {
            x[1] = value;
            kvp[i] = x.join('=');
            break;
          }
        }
        if (i < 0) {
          kvp[kvp.length] = [name, value].join('=');
        }
        let string = `${window.location.pathname  }?${  kvp.join('&')}`;
        if (value.length === 0) {
          string = string.replace(`?${  name  }=&`, "?");
          string = string.replace(`?${  name  }=`, "");
          string = string.replace(`&${  name  }=`, "");
          string = string.replace(`${name  }=`, "");
        }
        if (push === true) {
          window.history.pushState("", "", string);
          return string;
        }
        return string;

      }
    }], [{
      key: 'time',
      set: function set(int) {
        // int - int
        this.startTime = int;
      },
      get: function get() {
        return this.startTime;
      }
    }]);

    return V;
  }();

  const v = new V();

  // Preloader

  v.preloaderArray = [];

  v.preloader = function () {
    let _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#preloader",
        animationHome: 750,
        animationInnerHome: 1500,
        animation: 750,
        animationInner: 25,
        linksPreloader: true
      },
      _ref4$selector = _ref4.selector,
      selector = _ref4$selector === undefined ? "#preloader" : _ref4$selector,
      _ref4$animationHome = _ref4.animationHome,
      animationHome = _ref4$animationHome === undefined ? 750 : _ref4$animationHome,
      _ref4$animationInnerH = _ref4.animationInnerHome,
      animationInnerHome = _ref4$animationInnerH === undefined ? 1500 : _ref4$animationInnerH,
      _ref4$animation = _ref4.animation,
      animation = _ref4$animation === undefined ? 750 : _ref4$animation,
      _ref4$animationInner = _ref4.animationInner,
      animationInner = _ref4$animationInner === undefined ? 25 : _ref4$animationInner,
      _ref4$linksPreloader = _ref4.linksPreloader,
      linksPreloader = _ref4$linksPreloader === undefined ? true : _ref4$linksPreloader;

    const outer = document.querySelector(selector);
    if (outer === null) return false;

    const dateStart = new Date();

    animationInner = v.properties.template == 1 ? animationInnerHome : animationInner;
    animation = v.properties.template == 1 ? animationHome : animation;
    outer.style.opacity = '1';
    outer.style.transition = `${animation / 1000  }s`;
    outer.classList.add("start-animation");

    // show preloader

    function showPreloader(link) {
      const e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (e !== null) {
        e.preventDefault();
      }
      if (link.getAttribute("data-none-preloader") !== null) return;
      outer.classList.remove("hidden");
      outer.classList.remove("display-none");
      outer.style.transition = '0s';
      outer.style.opacity = '0';
      setTimeout(() => {
        outer.style.transition = '.25s';
        outer.style.opacity = '1';
      }, v.timeMin);
      setTimeout(((link) => {
        location.href = link.href;
      }).bind(this, link), v.timeMin + 250);
    }

    // hide preloader

    function hidePreloader() {

      function hidePreloaderFunc() {
        outer.style.opacity = '0';
        outer.classList.add("end-animation");
        setTimeout(() => {
          outer.classList.add("hidden");
          document.body.classList.remove("not-loaded");
          for (let i = 0; i < v.preloaderArray.length; i++) {
            v.preloaderArray[i]();
          }
          v.consoleInfo('Hide preloader');
        }, animation);
      }

      let dateEnd = new Date(),
        difference = +dateEnd - +dateStart;

      if (difference < animationInner) {
        setTimeout(hidePreloaderFunc.bind(this), animationInner - difference);
      } else {
        hidePreloaderFunc();
      }
    }

    // preloader run

    v.loadArray.push(hidePreloader.bind(this));

    // preloader links

    function events() {
      const linksPreloaderArray = document.querySelectorAll("a");
      for (let i = 0; i < linksPreloaderArray.length; i++) {
        if (linksPreloaderArray[i].getAttribute("data-rendered-preloader") !== null) continue;
        if (linksPreloaderArray[i].getAttribute("data-none-preloader") !== null) continue;
        if (linksPreloaderArray[i].getAttribute("target") !== null) continue;
        if (linksPreloaderArray[i].getAttribute("href") == null) continue;
        if (linksPreloaderArray[i].getAttribute("href") == "") continue;
        if (linksPreloaderArray[i].getAttribute("href") == "#") continue;
        if (linksPreloaderArray[i].getAttribute("href").includes("javascript:")) continue;
        if (linksPreloaderArray[i].getAttribute("href").includes("mailto:")) continue;
        if (linksPreloaderArray[i].getAttribute("href").includes("tel:")) continue;
        linksPreloaderArray[i].addEventListener("click", showPreloader.bind(this, linksPreloaderArray[i]));
        linksPreloaderArray[i].setAttribute("data-rendered-preloader", true);
      }
    }

    if (linksPreloader === true) {

      v.loadArray.push(() => {
        setTimeout(events.bind(this), 500);
      });
    }

    return {
      events,
      showPreloader: showPreloader.bind(this)
    };
  };

  // Scroll

  v.scroll = function () {
    let _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#wrap",
        addClassDocument: "v-scroll",
        notInit: false
      },
      _ref5$selector = _ref5.selector,
      selector = _ref5$selector === undefined ? "#wrap" : _ref5$selector,
      _ref5$addClassDocumen = _ref5.addClassDocument,
      addClassDocument = _ref5$addClassDocumen === undefined ? "v-scroll" : _ref5$addClassDocumen,
      _ref5$notInit = _ref5.notInit,
      notInit = _ref5$notInit === undefined ? false : _ref5$notInit;

    const outer = document.querySelector(selector);
    if (outer !== null) {
      outer.classList.add("scrollbar-macosx");
      document.documentElement.classList.add(addClassDocument);
    } else {
      return false;
    }

    v.consoleInfo(`Using customed scroll for: ${  outer}`);
  };

  // Checkbox

  v.checkbox = function () {
    let _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        outerSelector: ".v-checkbox",
        callback: function callback(checkbox, checked) {}
      },
      _ref6$outerSelector = _ref6.outerSelector,
      outerSelector = _ref6$outerSelector === undefined ? ".v-checkbox" : _ref6$outerSelector,
      _ref6$callback = _ref6.callback,
      callback = _ref6$callback === undefined ? function (checkbox, checked) {} : _ref6$callback;

    const elements = document.querySelectorAll(outerSelector);
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("v-checkbox");
      const checkbox = elements[i].querySelector("input[type='checkbox']");
      if (checkbox === null) continue;
      checkbox.classList.add("display-none");
      const div = document.createElement("div");
      elements[i].appendChild(div);
      const span = document.createElement("span");
      div.appendChild(span);
      elements[i].addEventListener("click", ((checkbox, outer) => {
        if (outer.classList.contains("disabled")) return false;
        $(checkbox).click();
      }).bind(this, checkbox, elements[i]));
      checkbox.addEventListener("change", ((checkbox, outer) => {
        checkedCheckbox(checkbox, outer);
      }).bind(this, checkbox, elements[i]));
      checkedCheckbox(checkbox, elements[i]);
    }

    function checkedCheckbox(checkbox, outer) {
      let checkboxId = checkbox.getAttribute("id"),
        continueLabel = false;
      if (checkboxId !== null & checkboxId !== '') continueLabel = true;
      else continueLabel = false;
      const label = document.querySelector(`label[for='${  checkboxId  }']`);
      if (label !== null & label !== '') continueLabel = true;
      else continueLabel = false;
      if (checkbox.checked === true) {
        outer.classList.add("checked");
        if (continueLabel === true) label.classList.add("active");
      } else {
        outer.classList.remove("checked");
        if (continueLabel === true) label.classList.remove("active");
      }
      callback(checkbox, checkbox.checked);
    }

    v.consoleInfo(`Using customed checkbox for: ${  elements}`);
  };

  // Radio

  v.radio = function () {
    let _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        outerSelector: ".v-radio",
        callback: function callback(radio, checked) {}
      },
      _ref7$outerSelector = _ref7.outerSelector,
      outerSelector = _ref7$outerSelector === undefined ? ".v-radio" : _ref7$outerSelector,
      _ref7$callback = _ref7.callback,
      callback = _ref7$callback === undefined ? function (radio, checked) {} : _ref7$callback;

    const elements = document.querySelectorAll(outerSelector);
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.add("v-radio");
      const radio = elements[i].querySelector("input[type='radio']");
      if (radio === null) continue;
      radio.classList.add("display-none");
      const div = document.createElement("div");
      elements[i].appendChild(div);
      const span = document.createElement("span");
      div.appendChild(span);
      elements[i].addEventListener("click", ((radio, outer) => {
        if (outer.classList.contains("disabled")) return false;
        $(radio).click();
      }).bind(this, radio, elements[i]));
      radio.addEventListener("change", ((radio, outer) => {
        checkedRadio(radio, outer);
      }).bind(this, radio, elements[i]));
      checkedRadio(radio, elements[i]);
    }

    function checkedRadio(radio, outer) {

      const name = radio.getAttribute("name");
      if (name === null || name === '') return false;

      const elements = document.querySelectorAll(`input[name='${  name  }']`);
      for (let _i3 = 0; _i3 < elements.length; _i3++) {
        let radioId = elements[_i3].getAttribute("id"),
          continueLabel = false;
        if (radioId !== null & radioId !== '') continueLabel = true;
        else continueLabel = false;
        const label = document.querySelector(`label[for='${  radioId  }']`);
        if (label !== null & label !== '') continueLabel = true;
        else continueLabel = false;
        if (elements[_i3].checked === true) {
          elements[_i3].parentNode.classList.add("checked");
          if (continueLabel === true) label.classList.add("active");
        } else {
          elements[_i3].parentNode.classList.remove("checked");
          if (continueLabel === true) label.classList.remove("active");
        }
        callback(elements[_i3], elements[_i3].checked);
      }
    }

    v.consoleInfo(`Using customed radio for: ${  elements}`);
  };

  // Map

  v.map = function () {
    let _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#contacts-map",
        style: [{
          "featureType": "all",
          "elementType": "all",
          "stylers": [{
            "hue": "#ff0000"
          }, {
            "saturation": -100
          }, {
            "lightness": -30
          }]
        }, {
          "featureType": "all",
          "elementType": "labels.text.fill",
          "stylers": [{
            "color": "#ffffff"
          }]
        }, {
          "featureType": "all",
          "elementType": "labels.text.stroke",
          "stylers": [{
            "color": "#353535"
          }]
        }, {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [{
            "color": "#656565"
          }]
        }, {
          "featureType": "poi",
          "elementType": "geometry.fill",
          "stylers": [{
            "color": "#505050"
          }]
        }, {
          "featureType": "poi",
          "elementType": "geometry.stroke",
          "stylers": [{
            "color": "#808080"
          }]
        }, {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [{
            "color": "#454545"
          }]
        }, {
          "featureType": "transit",
          "elementType": "labels",
          "stylers": [{
            "hue": "#000000"
          }, {
            "saturation": 100
          }, {
            "lightness": -40
          }, {
            "invert_lightness": true
          }, {
            "gamma": 1.5
          }]
        }],
        address: "London",
        icon: "assets/website/image/png-image/map.png",
        resizeType: "wh"
      },
      _ref8$selector = _ref8.selector,
      selector = _ref8$selector === undefined ? "#contacts-map" : _ref8$selector,
      _ref8$style = _ref8.style,
      style = _ref8$style === undefined ? [{
        "featureType": "all",
        "elementType": "all",
        "stylers": [{
          "hue": "#ff0000"
        }, {
          "saturation": -100
        }, {
          "lightness": -30
        }]
      }, {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#ffffff"
        }]
      }, {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [{
          "color": "#353535"
        }]
      }, {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [{
          "color": "#656565"
        }]
      }, {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#505050"
        }]
      }, {
        "featureType": "poi",
        "elementType": "geometry.stroke",
        "stylers": [{
          "color": "#808080"
        }]
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [{
          "color": "#454545"
        }]
      }, {
        "featureType": "transit",
        "elementType": "labels",
        "stylers": [{
          "hue": "#000000"
        }, {
          "saturation": 100
        }, {
          "lightness": -40
        }, {
          "invert_lightness": true
        }, {
          "gamma": 1.5
        }]
      }] : _ref8$style,
      _ref8$address = _ref8.address,
      address = _ref8$address === undefined ? "London" : _ref8$address,
      _ref8$icon = _ref8.icon,
      icon = _ref8$icon === undefined ? "assets/website/image/png-image/map.png" : _ref8$icon,
      _ref8$resizeType = _ref8.resizeType,
      resizeType = _ref8$resizeType === undefined ? "wh" : _ref8$resizeType;

    function init() {

      const outer = document.querySelector(selector);
      if (outer === null) return false;

      let outerMap = outer.querySelector("#map");
      if (outerMap === null) {
        outerMap = document.createElement("div");
        outerMap.setAttribute("id", "map");
        outerMap.classList.add("col-12");
        outerMap.classList.add("row-12");
        outer.appendChild(outerMap);
      } else {
        $(`${selector  } #map`).gmap3('destroy').remove();
        setTimeout(() => {
          outer.innerHTML = '<div id="map" class="col-12 row-12"></div>';
          outerMap = outer.querySelector("#map");
        }, v.timeMin);
      }

      setTimeout(() => {

        $(outerMap).gmap3({
          map: {
            options: {
              zoom: 16,
              mapTypeId: 'v_style',
              mapTypeControl: false,
              streetViewControl: false,
              mapTypeControlOptions: {
                mapTypeIds: ['v_style', google.maps.MapTypeId.TERRAIN]
              },
              scrollwheel: false
            }
          },
          getlatlng: {
            address,
            callback: function callback(results) {
              if (!results) return;
              $(this).gmap3('get').setCenter(new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng()));
              $(this).gmap3({
                marker: {
                  latLng: results[0].geometry.location,
                  labelClass: "map-label",
                  options: {
                    icon
                  }
                }
              });
            }
          },
          styledmaptype: {
            id: "v_style",
            options: {
              name: "V"
            },
            styles: style
          }
        });
      }, v.timeMin * 5);

      v.consoleInfo(`Using map for: ${  outer}`);

      return {
        init
      };
    }

    init();

    v.resizeArray.push([resizeType, init.bind(this)]);
  };

  // Select

  v.select = function () {
    let _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#select",
        selectorNew: "#select-new",
        classToAdd: "v-select-opened",
        callbackFirst: false,
        showSelected: false,
        arrow: false,
        scrollable: false,
        animate: 500,
        effect: 'fade', // fade, slide
        callback: function callback() {},
        callbackOpen: function callbackOpen() {},
        callbackClose: function callbackClose() {}
      },
      _ref9$selector = _ref9.selector,
      selector = _ref9$selector === undefined ? "#select" : _ref9$selector,
      _ref9$selectorNew = _ref9.selectorNew,
      selectorNew = _ref9$selectorNew === undefined ? "#select-new" : _ref9$selectorNew,
      _ref9$classToAdd = _ref9.classToAdd,
      classToAdd = _ref9$classToAdd === undefined ? "v-select-opened" : _ref9$classToAdd,
      _ref9$callbackFirst = _ref9.callbackFirst,
      callbackFirst = _ref9$callbackFirst === undefined ? false : _ref9$callbackFirst,
      _ref9$showSelected = _ref9.showSelected,
      showSelected = _ref9$showSelected === undefined ? false : _ref9$showSelected,
      _ref9$arrow = _ref9.arrow,
      arrow = _ref9$arrow === undefined ? false : _ref9$arrow,
      _ref9$scrollable = _ref9.scrollable,
      scrollable = _ref9$scrollable === undefined ? false : _ref9$scrollable,
      _ref9$animate = _ref9.animate,
      animate = _ref9$animate === undefined ? 500 : _ref9$animate,
      _ref9$effect = _ref9.effect,
      effect = _ref9$effect === undefined ? 'fade' : _ref9$effect,
      _ref9$callback = _ref9.callback,
      callback = _ref9$callback === undefined ? function () {} : _ref9$callback,
      _ref9$callbackOpen = _ref9.callbackOpen,
      callbackOpen = _ref9$callbackOpen === undefined ? function () {} : _ref9$callbackOpen,
      _ref9$callbackClose = _ref9.callbackClose,
      callbackClose = _ref9$callbackClose === undefined ? function () {} : _ref9$callbackClose;

    let opened = true,
      options = [],
      outerNewClass = "v-select",
      outerNewDivClass = "selected",
      outer = false,
      outerNew = false,
      activeClass = "active",
      active = 0,
      changes = 0,
      arrayLi = [],
      div = false,
      outerUl = false,
      outerUlContent = false,
      ul = false,
      run = false;

    function init() {

      outer = document.querySelector(selector);
      if (outer === null) return false;

      outerNew = document.querySelector(selectorNew);
      if (outerNew === null) return false;

      run = true;

      // classes

      outer.classList.add("display-none");
      outerNew.classList.add(outerNewClass);
      if (showSelected === true) {
        outerNew.classList.add("show-selected");
      }
      if (arrow === true) {
        outerNew.classList.add("arrow-select");
      }

      // div
      div = document.createElement("div");
      div.classList.add(outerNewDivClass);
      outerNew.appendChild(div);
      div.onclick = openClose.bind(this);

      // outer ul
      outerUl = document.createElement("div");
      outerUl.classList.add("outer-ul");
      outerNew.appendChild(outerUl);

      // outer ul
      outerUlContent = document.createElement("div");
      outerUlContent.classList.add("outer-ul-content");
      outerUl.appendChild(outerUlContent);
      if (scrollable === true) {
        const randClass = v.randInt({
          min: 0,
          max: 100000
        });
        outerUlContent.setAttribute("id", `outer-ul-content-${  randClass}`);
        outerNew.classList.add("scrollable");
        v.scroll({
          selector: `#outer-ul-content-${  randClass}`,
          addClassDocument: `v-scroll-select-${  randClass}`
        });
      }

      // outer ul
      ul = document.createElement("ul");
      outerUlContent.appendChild(ul);

      // li
      let text = void 0,
        li = void 0;
      for (let i = 0, a = 0; i < outer.children.length; i++) {
        if (outer.children[i].tagName == "OPTION") {
          text = outer.children[i].innerHTML;
          li = document.createElement("li");
          li.classList.add("v-select-li");
          li.innerHTML = text;
          if (outer.children[i].getAttribute("selected") !== null) {
            li.classList.add(activeClass);
            div.innerHTML = text;
            active = a;
          }
          arrayLi.push(li);
          li.onclick = change.bind(this, a);
          ul.appendChild(li);
          options.push(outer.children[i]);
          a++;
        }
      }

      window.addEventListener("click", (e) => {
        if ($(outerNew).has(e.target).length === 0) {
          if (opened === true) {
            openClose();
          }
        }
      });

      v.consoleInfo(`Using select for: ${  outer}`);
    }

    init();
    if (run !== true) return;
    change(active);

    // change

    function change() {
      let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      num = parseInt(num);
      for (let _i4 = 0; _i4 < options.length; _i4++) {
        options[_i4].removeAttribute("selected");
      }
      for (let i = 0; i < arrayLi.length; i++) {
        arrayLi[i].classList.remove(activeClass);
      }
      options[num].setAttribute("selected", true);
      arrayLi[num].classList.add(activeClass);
      div.innerHTML = `<span>${  options[num].innerHTML  }</span>`;
      if (changes === 0) {
        if (callbackFirst === true) {
          callback(options[num], outer, outerNew);
        }
      } else {
        callback(options[num], outer, outerNew);
      }
      if (opened === true) {
        openClose();
      }
      changes++;
    }

    // open close

    function openClose() {
      if (opened == false) {
        outerNew.classList.add("opened");
        opened = true;
        document.documentElement.classList.add(classToAdd);
        if (effect === 'fade') {
          $(outerUl).stop().fadeIn(animate);
        } else {
          $(outerUl).stop().slideDown(animate);
        }
        callbackOpen();
      } else {
        outerNew.classList.remove("opened");
        opened = false;
        document.documentElement.classList.remove(classToAdd);
        if (effect === 'fade') {
          $(outerUl).stop().fadeOut(animate);
        } else {
          $(outerUl).stop().slideUp(animate);
        }
        callbackClose();
      }
    }

    return {
      change,
      openClose
    };
  };

  // Sticky Scroll

  v.stickyScroll = function () {
    let _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: ".screen",
        outerSelector: "#wrap",
        max: 100,
        animate: 500,
        up: true,
        down: true
      },
      _ref10$selector = _ref10.selector,
      selector = _ref10$selector === undefined ? ".screen" : _ref10$selector,
      _ref10$outerSelector = _ref10.outerSelector,
      outerSelector = _ref10$outerSelector === undefined ? "#wrap" : _ref10$outerSelector,
      _ref10$max = _ref10.max,
      max = _ref10$max === undefined ? 100 : _ref10$max,
      _ref10$animate = _ref10.animate,
      animate = _ref10$animate === undefined ? 500 : _ref10$animate,
      _ref10$up = _ref10.up,
      up = _ref10$up === undefined ? true : _ref10$up,
      _ref10$down = _ref10.down,
      down = _ref10$down === undefined ? true : _ref10$down;

    let on = true,
      elements = [],
      outer = false,
      run = false,
      scrollDirection = 'down',
      // up, down
      scrollPrev = 0,
      scrollVal = 0,
      scrolling = false;

    // init

    function init() {

      elements = document.querySelectorAll(selector);
      if (elements.length === 0) {
        run = false;
        return false;
      }

      outer = document.querySelector(outerSelector);
      if (outer === null) {
        run = false;
        return false;
      }

      outer.addEventListener("scroll", scroll.bind(this));

      run = true;

      v.consoleInfo(`Using sticky scroll for: ${  outer}`);
    }

    // scroll

    function scroll() {

      if (on !== true) return false;
      if (scrolling === true) return false;

      scrollPrev = scrollVal;
      scrollVal = outer.scrollTop;
      if (scrollPrev < scrollVal) scrollDirection = 'down';
      else scrollDirection = 'up';

      for (let i = 0; i < elements.length; i++) {

        const missing = elements[i].getBoundingClientRect().top;

        if (scrollDirection === 'down' & up === true) {
          if (missing <= max & missing > max / 5) {
            scrolling = true;
            outer.scrollTop = scrollPrev;
            $(outer).animate({
              scrollTop: outer.scrollTop + $(elements[i]).offset().top
            }, animate, () => {
              scrolling = false;
            });
          }
        }

        const missingUp = outer.clientHeight - elements[i].getBoundingClientRect().bottom;

        if (scrollDirection === 'up' & down === true) {
          if (missingUp > max / 5 & missingUp <= max) {
            scrolling = true;
            outer.scrollTop = scrollPrev;
            $(outer).animate({
              scrollTop: outer.scrollTop + $(elements[i]).offset().top
            }, animate, () => {
              scrolling = false;
            });
          }
        }
      }
    }

    // turn

    function turn() {
      const data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'on';
      // on, off
      if (data === "on") {
        on = true;
      } else {
        on = false;
      }
    }

    init();
    if (run !== true) return;

    return {
      turn
    };
  };

  // Parallax

  v.parallax = function () {
    let _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: ".parallax",
        outerSelector: "#wrap",
        multiply: 50,
        tillEnd: true
      },
      _ref11$selector = _ref11.selector,
      selector = _ref11$selector === undefined ? ".parallax" : _ref11$selector,
      _ref11$outerSelector = _ref11.outerSelector,
      outerSelector = _ref11$outerSelector === undefined ? "#wrap" : _ref11$outerSelector,
      _ref11$multiply = _ref11.multiply,
      multiply = _ref11$multiply === undefined ? 50 : _ref11$multiply,
      _ref11$tillEnd = _ref11.tillEnd,
      tillEnd = _ref11$tillEnd === undefined ? true : _ref11$tillEnd;

    let on = true,
      elements = [],
      outer = false,
      run = false,
      scrollVal = 0,
      heightVal = 0;

    // init

    function init() {

      elements = document.querySelectorAll(selector);
      if (elements.length === 0) {
        run = false;
        return false;
      }

      for (let i = 0; i < elements.length; i++) {
        if (elements[i].parallaxStart === undefined) {
          elements[i].parallaxStart = elements[i].getBoundingClientRect().top;
        }
        if (elements[i].getAttribute("parallax-start") !== null) {
          elements[i].parallaxStart = elements[i].getAttribute("parallax-start");
        }
        if (elements[i].parallaxEnd === undefined) {
          elements[i].parallaxEnd = elements[i].getBoundingClientRect().bottom;
        }
      }

      if (outerSelector !== window) {
        outer = document.querySelector(outerSelector);
      } else {
        outer = window;
      }

      if (outer === null) {
        run = false;
        return false;
      }

      outer.addEventListener("scroll", scroll.bind(this));

      run = true;

      v.consoleInfo(`Using parallax for: ${  elements}`);
    }

    // scroll

    function scroll() {

      if (on !== true) return false;

      scrollVal = outer === window ? outer.pageYOffset : outer.scrollTop;
      heightVal = outer === window ? document.documentElement.clientHeight : outer.clientHeight;

      for (let i = 0; i < elements.length; i++) {

        elements[i].parallaxStart = 0;
        let start = scrollVal - elements[i].parallaxStart;
        if (elements[i].parallaxStart >= heightVal) start += heightVal;
        let end = heightVal;
        if (tillEnd === true) end += elements[i].clientHeight;

        if (start >= 0 & start <= end) {
          const percent = start / end;
          const parallaxTop = percent * (multiply * elements[i].clientHeight / 100);
          elements[i].style.transform = `translate3d(0, ${  parallaxTop  }px, 0)`;
        } else {
          if (start < 0) {
            elements[i].style.transform = "";
          }
          return false;
        }
      }
    }

    // turn

    function turn() {
      const data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'on';
      // on, off
      if (data === "on") {
        on = true;
      } else {
        on = false;
      }
    }

    init();
    if (run !== true) return;

    return {
      turn
    };
  };

  // In View

  v.inView = function () {
    let _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: ".item",
        outerSelector: "#wrap",
        percentPosition: 30,
        callback: function callback(e) {},
        callbackReturn: function callbackReturn(e) {}
      },
      _ref12$selector = _ref12.selector,
      selector = _ref12$selector === undefined ? ".item" : _ref12$selector,
      _ref12$outerSelector = _ref12.outerSelector,
      outerSelector = _ref12$outerSelector === undefined ? "#wrap" : _ref12$outerSelector,
      _ref12$percentPositio = _ref12.percentPosition,
      percentPosition = _ref12$percentPositio === undefined ? 30 : _ref12$percentPositio,
      _ref12$callback = _ref12.callback,
      callback = _ref12$callback === undefined ? function (e) {} : _ref12$callback,
      _ref12$callbackReturn = _ref12.callbackReturn,
      callbackReturn = _ref12$callbackReturn === undefined ? function (e) {} : _ref12$callbackReturn;

    let on = true,
      elements = [],
      outer = false,
      run = false,
      scrollVal = 0,
      heightVal = 0,
      percentVal = 0;

    // init

    function init() {

      elements = document.querySelectorAll(selector);
      if (elements.length === 0) {
        run = false;
        return false;
      }
      for (let i = 0; i < elements.length; i++) {
        elements[i].callback = false;
        elements[i].callbackAgain = false;
      }

      if (outerSelector !== window) {
        outer = document.querySelector(outerSelector);
      } else {
        outer = window;
      }

      if (outer === null) {
        run = false;
        return false;
      }

      outer.addEventListener("scroll", scroll.bind(this));

      run = true;

      v.consoleInfo(`Using inView for: ${  elements}`);
    }

    // scroll

    function scroll() {

      if (on !== true) return false;

      scrollVal = outer === window ? outer.pageYOffset : outer.scrollTop;
      heightVal = outer === window ? document.documentElement.clientHeight : outer.clientHeight;
      percentVal = percentPosition * heightVal / 100;

      for (let i = 0; i < elements.length; i++) {
        const bounding = elements[i].getBoundingClientRect();
        if (bounding.top <= percentVal & elements[i].callbackAgain === false || bounding.bottom >= percentVal & elements[i].callbackAgain === true) {
          if (bounding.top >= elements[i].clientHeight * -1) {
            if (elements[i].callback === true) continue;
            callback(elements[i]);
            elements[i].callback = true;
            elements[i].callbackAgain = false;
          } else {
            if (elements[i].callback === false) continue;
            callbackReturn(elements[i]);
            elements[i].callback = false;
            elements[i].callbackAgain = true;
          }
        }
      }
    }

    // turn

    function turn() {
      const data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'on';
      // on, off
      if (data === "on") {
        on = true;
      } else {
        on = false;
      }
    }

    init();
    if (run !== true) return;

    return {
      turn
    };
  };

  // Video

  v.video = function () {

    let videoArr = document.querySelectorAll("*[data-video='v']"),
      video = void 0,
      videoElement = void 0,
      source = void 0,
      controls = void 0,
      preload = void 0,
      posterElement = void 0,
      playElement = void 0,
      poster = void 0,
      playText = void 0,
      mp4 = void 0,
      webm = void 0,
      ogv = void 0;

    for (let i = 0; i < videoArr.length; i++) {

      video = videoArr[i];

      video.classList.add("v-video");

      controls = video.getAttribute("data-video-controls");
      preload = video.getAttribute("data-video-preload");
      poster = video.getAttribute("data-video-poster");
      playText = video.getAttribute("data-video-play-text");
      mp4 = video.getAttribute("data-video-mp4");
      webm = video.getAttribute("data-video-webm");
      ogv = video.getAttribute("data-video-ogv");

      // VIDEO
      videoElement = document.createElement("video");
      if (controls !== null) {
        videoElement.setAttribute("controls", controls);
      }
      if (preload !== null) {
        videoElement.setAttribute("preload", preload);
      }
      video.appendChild(videoElement);

      // SOURCE
      if (mp4 !== null) {
        source = document.createElement("source");
        source.setAttribute("type", "video/mp4");
        source.setAttribute("src", mp4);
        videoElement.appendChild(source);
      }
      if (webm !== null) {
        source = document.createElement("source");
        source.setAttribute("type", "video/webm");
        source.setAttribute("src", webm);
        videoElement.appendChild(source);
      }
      if (ogv !== null) {
        source = document.createElement("source");
        source.setAttribute("type", "video/ogg");
        source.setAttribute("src", ogv);
        videoElement.appendChild(source);
      }

      // Poster
      if (poster !== null) {

        posterElement = document.createElement("div");
        posterElement.classList.add("poster");
        posterElement.classList.add("transition");
        posterElement.style.backgroundImage = `url(${  poster  })`;
        video.appendChild(posterElement);

        playElement = document.createElement("div");
        playElement.classList.add("play");
        playElement.classList.add("transition");
        playElement.innerHTML = playText !== null ? playText : '';
        video.appendChild(playElement);

        // Event
        posterElement.onclick = posterClickPlay.bind(this, videoElement, posterElement, playElement);
        playElement.onclick = posterClickPlay.bind(this, videoElement, posterElement, playElement);
        // Event Video
        videoElement.onpause = videoPause.bind(this, videoElement, posterElement, playElement);
        videoElement.onclick = function () {
          videoElement.pause();
        };
      }
    }

    // Events

    function posterClickPlay(video, poster, play) {
      poster.classList.add("zero-opacity");
      play.classList.add("zero-opacity");
      setTimeout(() => {
        video.play();
        poster.classList.add("display-none");
        play.classList.add("display-none");
      }, 500);
    }

    function videoPause(video, poster, play) {
      if (video.seeking == false) {
        poster.classList.remove("display-none");
        play.classList.remove("display-none");
        setTimeout(() => {
          poster.classList.remove("zero-opacity");
          play.classList.remove("zero-opacity");
        }, v.timeMin);
      }
    }
  };

  // Columns

  v.columns = function () {
    let _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#columns",
        selectorItems: ".item",
        columns: 3,
        direction: "012"
      },
      _ref13$selector = _ref13.selector,
      selector = _ref13$selector === undefined ? "#columns" : _ref13$selector,
      _ref13$selectorItems = _ref13.selectorItems,
      selectorItems = _ref13$selectorItems === undefined ? ".item" : _ref13$selectorItems,
      _ref13$columns = _ref13.columns,
      columns = _ref13$columns === undefined ? 3 : _ref13$columns,
      _ref13$direction = _ref13.direction,
      direction = _ref13$direction === undefined ? "012" : _ref13$direction;

    let outer = false,
      elements = [],
      run = false,
      columnsPrev = false,
      html = '';

    // init

    function init() {

      outer = document.querySelector(selector);
      if (outer === null) {
        run = false;
        return false;
      }
      outer.classList.add("v-columns");
      outer.classList.add(`columns-${  columns}`);

      html = outer.innerHTML;

      run = true;

      v.consoleInfo(`Using Columns for: ${  outer}`);
    }

    // divide

    function divide() {

      outer.innerHTML = html;

      // create columns

      let columnsArray = [],
        columnsArrayAdd = [],
        newColumn = false,
        directionColumns = direction.split("");
      for (let i = 0; i < columns; i++) {
        newColumn = document.createElement("div");
        newColumn.classList.add("column");
        newColumn.classList.add(`column-${  i}`);
        columnsArray[parseInt(directionColumns[i])] = newColumn;
        columnsArrayAdd[i] = newColumn;
      }
      for (let _i5 = 0; _i5 < columnsArray.length; _i5++) {
        outer.appendChild(columnsArray[_i5]);
      }

      const items = outer.querySelectorAll(selectorItems);
      for (let _i6 = 0, a = 0; _i6 < items.length; _i6++) {
        if (a >= columns) a = 0;
        columnsArrayAdd[a].appendChild(items[_i6]);
        a++;
      }

      outer.innerHTML += '<div class="clear"></div>';
    }

    // change columns

    function changeColumns() {
      const num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      const directionNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "012";


      columnsPrev = columns;
      outer.classList.remove(`columns-${  columnsPrev}`);
      columns = num;
      outer.classList.add(`columns-${  columns}`);
      direction = directionNew;
      divide();
    }

    // add content

    function addContent() {
      const data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";


      html += data;
      divide();
    }

    init();
    if (run !== true) return;

    divide();

    return {
      changeColumns,
      addContent
    };
  };

  // Ajax Load

  v.ajaxContent = function () {
    var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#ajax-content",
        selectorAjax: selector,
        callback: function callback(outer, html) {},
        callbackReload: function callbackReload(outer, html) {},
        callbackLast: function callbackLast(outer, html) {},
        callbackEmpty: function callbackEmpty() {}
      },
      _ref14$selector = _ref14.selector,
      selector = _ref14$selector === undefined ? "#ajax-content" : _ref14$selector,
      _ref14$selectorAjax = _ref14.selectorAjax,
      selectorAjax = _ref14$selectorAjax === undefined ? selector : _ref14$selectorAjax,
      _ref14$callback = _ref14.callback,
      callback = _ref14$callback === undefined ? function (outer, html) {} : _ref14$callback,
      _ref14$callbackReload = _ref14.callbackReload,
      callbackReload = _ref14$callbackReload === undefined ? function (outer, html) {} : _ref14$callbackReload,
      _ref14$callbackLast = _ref14.callbackLast,
      callbackLast = _ref14$callbackLast === undefined ? function (outer, html) {} : _ref14$callbackLast,
      _ref14$callbackEmpty = _ref14.callbackEmpty,
      callbackEmpty = _ref14$callbackEmpty === undefined ? function () {} : _ref14$callbackEmpty;

    let outer = false,
      max = 1,
      current = 1,
      url = '',
      run = false,
      loading = false;

    // init

    function init() {

      outer = document.querySelector(selector);
      if (outer === null) {
        run = false;
        return false;
      }

      max = outer.getAttribute("data-ajax-max");
      if (max === null) {
        run = false;
        return false;
      }
      max = parseInt(max);

      current = outer.getAttribute("data-ajax-current");
      if (current === null) {
        run = false;
        return false;
      }
      current = parseInt(current);

      if (max === current) callbackEmpty();

      url = location.href;

      run = true;

      v.consoleInfo(`Using ajax content for: ${  outer}`);
    }

    // load more

    function loadMore() {

      if (current >= max || loading === true) {
        return false;
      }

      url = v.setParameter({
        name: 'page',
        value: current + 1,
        push: false
      });

      const currentPost = $.post(url, {
        ajaxPost: 1
      }, insert.bind(this, false)).fail(() => {
        loadMore();
      });

      setTimeout(((p) => {
        p.abort();
      }).bind(this, currentPost), v.ajaxMaxTime);

      loading = true;
    }

    // reload

    function reload() {

      if (url !== location.href) {
        current = 1;
      }
      url = v.setParameter({
        name: 'page',
        value: current,
        push: false
      });

      const currentPost = $.post(url, {
        ajaxPost: 1
      }, insert.bind(this, true)).fail(() => {
        reload();
      });

      setTimeout(((p) => {
        p.abort();
      }).bind(this, currentPost), v.ajaxMaxTime);

      loading = true;
    }

    // insert

    function insert() {
      const reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      const html = arguments[1];


      const newElement = document.createElement("div");
      newElement.innerHTML = html;

      let currentTitle = document.querySelector("title"),
        newTitle = newElement.querySelector("title");
      if (currentTitle !== null & newTitle !== null) {
        currentTitle.innerHTML = newTitle.innerHTML;
      }

      let newOuter = newElement.querySelector(selectorAjax),
        newHtml = '';
      if (newOuter === null) {
        return false;
      }
      newHtml = newOuter.innerHTML;


      max = newOuter.getAttribute("data-ajax-max");
      if (max === null) {
        max = 1;
        return false;
      }
      max = parseInt(max);

      // callbacks
      if (reload === true) {
        callbackReload(outer, newHtml);
        if (current >= max) {
          callbackLast(outer, newHtml);
        }
      } else {
        callback(outer, newHtml);
      }

      if (reload !== true) {
        current++;
      }

      if (current >= max) {
        callbackLast(outer, newHtml);
      }

      loading = false;
    }

    init();
    if (run !== true) return;

    return {
      loadMore,
      reload,
      outer
    };
  };

  // Popup

  v.popupOpenFirst = function () {};
  v.popupCloseFirst = function () {};
  v.popupOpenSecond = function () {};
  v.popupCloseSecond = function () {};

  v.popup = function () {

    // Define

    let outer = void 0,
      container = void 0,
      content = void 0,
      firstLevel = void 0,
      secondLevel = void 0,
      overlay = void 0,
      close = void 0;

    let firstLevelShown = false,
      secondLevelShown = false,
      typePopup = "standard",
      closeAllBool = false;

    // Create

    function create() {

      // Outer
      outer = document.createElement("div");
      outer.setAttribute("id", "v-popup");
      outer.classList.add("transition");
      outer.classList.add("display-none");

      // Overlay
      overlay = document.createElement("div");
      overlay.classList.add("overlay");
      overlay.onclick = closeFunc.bind(this);
      outer.appendChild(overlay);

      // Container
      container = document.createElement("div");
      container.classList.add("container");
      outer.appendChild(container);

      // Content
      content = document.createElement("div");
      content.classList.add("content");
      container.appendChild(content);

      // First Level
      firstLevel = document.createElement("div");
      firstLevel.classList.add("first-level");
      content.appendChild(firstLevel);

      // Second Level
      secondLevel = document.createElement("div");
      secondLevel.classList.add("second-level");
      content.appendChild(secondLevel);

      /* Close */

      close = document.createElement("div");
      close.classList.add("close");
      container.appendChild(close);
      close.onclick = closeFunc.bind(this);

      document.body.appendChild(outer);
    }

    // Video Off

    function videoOff() {
      const video = outer.querySelectorAll("video");
      for (let i = 0; i < video.length; i++) {
        video[i].pause();
      }
    }

    // Close Func

    function closeFunc() {

      if (closeAllBool !== true) {
        if (secondLevelShown === true) {
          closeSecond();
        } else {
          closeFirst();
        }
      } else {
        closeAll();
        closeAllBool = false;
      }

      videoOff();
    }

    // Close First

    function closeFirst() {

      if (secondLevelShown === true) {
        return false;
      }

      firstLevelShown = false;
      secondLevelShown = false;

      outer.classList.remove("first-level");

      document.documentElement.classList.remove("popup-first-level-open");
      document.documentElement.classList.remove("popup-second-level-open");
      const typePopupSplit = typePopup.split(" ");
      for (let i = 0; i < typePopupSplit.length; i++) {
        document.documentElement.classList.remove(`popup-first-level-open-${  typePopupSplit[i]}`);
      }

      setTimeout(() => {
        document.documentElement.classList.remove("popup-open");
        outer.classList.add("display-none");
        outer.classList.remove("display-flex");
        const typePopupSplit = typePopup.split(" ");
        for (let _i7 = 0; _i7 < typePopupSplit.length; _i7++) {
          outer.classList.remove(typePopupSplit[_i7]);
        }
        v.popupCloseFirst();
        firstLevel.innerHTML = '';
        close.innerHTML = '';
      }, 500);
    }

    // Close Second

    function closeSecond() {

      if (secondLevelShown !== true) {
        return false;
      }

      firstLevelShown = true;
      secondLevelShown = false;

      setTimeout(() => {
        outer.classList.remove("second-level");
        document.documentElement.classList.remove("popup-second-level-open");
        v.popupCloseSecond();
      }, v.timeMin);

      setTimeout(() => {
        secondLevel.innerHTML = '';
      }, 500);
    }

    // Close All

    function closeAll() {

      firstLevelShown = false;
      secondLevelShown = false;

      outer.classList.remove("first-level");

      document.documentElement.classList.remove("popup-first-level-open");
      document.documentElement.classList.remove("popup-second-level-open");
      const typePopupSplit = typePopup.split(" ");
      for (let i = 0; i < typePopupSplit.length; i++) {
        document.documentElement.classList.remove(`popup-first-level-open-${  typePopupSplit[i]}`);
      }

      setTimeout(() => {
        document.documentElement.classList.remove("popup-open");
        outer.classList.add("display-none");
        outer.classList.remove("display-flex");
        const typePopupSplit = typePopup.split(" ");
        for (let _i8 = 0; _i8 < typePopupSplit.length; _i8++) {
          outer.classList.remove(typePopupSplit[_i8]);
        }
        v.popupCloseFirst();
        firstLevel.innerHTML = '';
        outer.classList.remove("second-level");
        v.popupCloseSecond();
        secondLevel.innerHTML = '';
      }, 500);
    }

    // Open First

    function openFirst() {
      const type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'html';
      const selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#v-popup-content";
      const typePopupClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "standard";
      const closeHTML = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '<div class="line"></div><div class="line"></div>';
      const closeAllBoolArg = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


      firstLevelShown = true;
      secondLevelShown = false;

      typePopup = typePopupClass;

      if (type == 'html') {
        firstLevel.innerHTML = selector;
      } else {
        const e = document.querySelector(selector);
        if (e !== null) {
          firstLevel.innerHTML = e.innerHTML;
        }
      }
      firstLevel.innerHTML += '<div class="after-close"></div>';
      closeAllBool = closeAllBoolArg;

      outer.classList.remove("display-none");
      outer.classList.add("display-flex");
      document.documentElement.classList.add("popup-open");
      const typePopupSplit = typePopup.split(" ");
      for (let i = 0; i < typePopupSplit.length; i++) {
        outer.classList.add(typePopupSplit[i]);
      }
      close.innerHTML = closeHTML;

      setTimeout(() => {
        outer.classList.add("first-level");
        outer.classList.remove("second-level");
        document.documentElement.classList.add("popup-first-level-open");
        const typePopupSplit = typePopup.split(" ");
        for (let _i9 = 0; _i9 < typePopupSplit.length; _i9++) {
          document.documentElement.classList.add(`popup-first-level-open-${  typePopupSplit[_i9]}`);
        }
        document.documentElement.classList.remove("popup-second-level-open");
        v.popupOpenFirst();
      }, v.timeMin);

      firstLevel.querySelector(".after-close").onclick = function () {
        if (secondLevelShown === true) {
          closeFunc();
        }
      };

      const closeButtons = firstLevel.querySelectorAll(".close-button");
      for (let _i10 = 0; _i10 < closeButtons.length; _i10++) {
        closeButtons[_i10].addEventListener("click", function () {
          const e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

          if (e !== null) e.preventDefault();
          closeFunc();
        });
      }
    }

    // Open Second

    function openSecond() {
      const type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'html';
      const selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#v-popup-content";


      if (firstLevelShown !== true) {
        return false;
      }

      firstLevelShown = true;
      secondLevelShown = true;

      if (type == 'html') {
        secondLevel.innerHTML = selector;
      } else {
        const e = document.querySelector(selector);
        if (e !== null) {
          secondLevel.innerHTML = e.innerHTML;
        }
      }

      setTimeout(() => {
        outer.classList.add("second-level");
        document.documentElement.classList.add("popup-second-level-open");
        v.popupOpenSecond();
      }, v.timeMin);

      const closeButtons = secondLevel.querySelectorAll(".close-button");
      for (let i = 0; i < closeButtons.length; i++) {
        closeButtons[i].addEventListener("click", function () {
          const e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

          if (e !== null) e.preventDefault();
          closeFunc();
        });
      }
    }

    create();

    return {
      openFirst,
      openSecond,
      closeFirst,
      closeSecond,
      closeAll
    };
  };

  v.popup = v.popup();

  // Form Event

  $('form,input,select,textarea').attr("autocomplete", "off");

  v.formEventForm = false;
  v.formEventSubmit = false;
  v.formEventInputsArray = [];

  v.formEvent = function () {
    let _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        form: null,
        addClass: true,
        callback: function callback(form) {},
        callbackError: function callbackError(form) {},
        callbackDisabled: function callbackDisabled(disabled) {},
        scrollWrapSelector: "#wrap",
        scrollToInput: false,
        clear: true
      },
      _ref15$form = _ref15.form,
      form = _ref15$form === undefined ? null : _ref15$form,
      _ref15$addClass = _ref15.addClass,
      addClass = _ref15$addClass === undefined ? true : _ref15$addClass,
      _ref15$callback = _ref15.callback,
      callback = _ref15$callback === undefined ? function (form) {} : _ref15$callback,
      _ref15$callbackError = _ref15.callbackError,
      callbackError = _ref15$callbackError === undefined ? function (form) {} : _ref15$callbackError,
      _ref15$callbackDisabl = _ref15.callbackDisabled,
      callbackDisabled = _ref15$callbackDisabl === undefined ? function (disabled) {} : _ref15$callbackDisabl,
      _ref15$scrollWrapSele = _ref15.scrollWrapSelector,
      scrollWrapSelector = _ref15$scrollWrapSele === undefined ? "#wrap" : _ref15$scrollWrapSele,
      _ref15$scrollToInput = _ref15.scrollToInput,
      scrollToInput = _ref15$scrollToInput === undefined ? false : _ref15$scrollToInput,
      _ref15$clear = _ref15.clear,
      clear = _ref15$clear === undefined ? true : _ref15$clear;

    if (form === null) return false;
    v.formEventForm = form;
    v.formEventSubmit = form.querySelector("input[type='submit']");
    if (v.formEventSubmit === null) return false;

    v.formEventSubmit.setAttribute("disabled", 'disabled');
    callbackDisabled(v.formEventSubmit.disabled, v.formEventSubmit);

    let inputsArray = form.querySelectorAll("input:not([type='submit']):not([type='button']), textarea, select"),
      inputsObject = {},
      inputsJSON = void 0;

    for (let i = 0; i < inputsArray.length; i++) {
      const inputName = inputsArray[i].getAttribute("name");
      if (inputName === null || inputName === '') continue;
      inputsObject[inputName] = inputsArray[i].value;
    }

    // JSON

    v.formEventInputsArray = inputsArray;
    inputsJSON = $(v.formEventForm).serializeObject();

    const action = form.action;
    if (action === null || action === '') return false;

    const src = form.action;
    if (src === null || src === '') return false;

    // AJAX

    const refArguments = arguments[0];
    const currentPost = $.post(src, {
      inputs: inputsJSON
    }, afterPostFunction.bind(this, callback)).fail(() => {
      v.formEvent(refArguments);
    });

    setTimeout(((p) => {
      p.abort();
    }).bind(this, currentPost), v.ajaxMaxTime);

    // Callback

    function afterPostFunction(callback, data) {

      v.formEventSubmit.removeAttribute("disabled");
      callbackDisabled(v.formEventSubmit.disabled, v.formEventSubmit);

      for (var i = 0; i < v.formEventInputsArray.length; i++) {
        v.formEventInputsArray[i].classList.remove("error");
        const parent = v.formEventInputsArray[i].parentNode;
        if (parent.classList.contains("v-input")) {
          parent.classList.remove("error");
        }
      }

      if (data.substring(0, 2) !== 'ok') {

        if (data == "error") alert("error");

        if (addClass === true) {

          let dataArray = data.split(" "),
            string = '';
          for (let _i11 = 0; _i11 < dataArray.length; _i11++) {
            string += `, *[name='${  dataArray[_i11]  }']`;
          }
          string = string.substring(2);

          const inputs = v.formEventForm.querySelectorAll(string);
          for (let _i12 = 0; _i12 < inputs.length; _i12++) {
            inputs[_i12].classList.add("error");
            const _parent = inputs[_i12].parentNode;
            if (_parent.classList.contains("v-input")) {
              _parent.classList.add("error");
            }
            if (scrollToInput === true) {
              const scrollWrap = document.querySelector(scrollWrapSelector);
              if (scrollWrap !== null) {
                const inputOffset = $(inputs[_i12]).offset().top;
                if (inputOffset < v.viewportHeight[1] / 2 || inputOffset > v.viewportHeight[1] * .75) {
                  $(scrollWrap).stop().animate({
                    scrollTop: $(scrollWrap).scrollTop() + inputOffset - v.viewportHeight[1] / 2
                  }, 500);
                }
              }
            }
          }
        }

        callbackError.call(this, v.formEventForm, data);
      } else {

        for (var i = 0; i < v.formEventInputsArray.length; i++) {
          if (v.formEventInputsArray[i].getAttribute("type") !== 'hidden') {
            if (clear === true) v.formEventInputsArray[i].value = '';
          }
        }

        callback.call(this, v.formEventForm, data);
      }
    }
  };

  // Slider

  v.slider = function () {
    let _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#v-slider",
        prevText: 'Prev',
        nextText: 'Next',
        textControlsContent: true,
        beforeChange: function beforeChange() {},
        afterChange: function afterChange() {},
        animation: 1000,
        wheelBool: false,
        keyBool: false,
        swipeBool: false,
        intervalBool: false,
        interval: 5000,
        slideType: false,
        title: 'Slider',
        backTitle: 'Back',
        changeTitle: true,
        ignoreDeny: false,
        onSlideTypeShown: function onSlideTypeShown() {},
        onSlideTypeHidden: function onSlideTypeHidden() {}
      },
      _ref16$selector = _ref16.selector,
      selector = _ref16$selector === undefined ? "#v-slider" : _ref16$selector,
      _ref16$prevText = _ref16.prevText,
      prevText = _ref16$prevText === undefined ? 'Prev' : _ref16$prevText,
      _ref16$nextText = _ref16.nextText,
      nextText = _ref16$nextText === undefined ? 'Next' : _ref16$nextText,
      _ref16$textControlsCo = _ref16.textControlsContent,
      textControlsContent = _ref16$textControlsCo === undefined ? true : _ref16$textControlsCo,
      _ref16$beforeChange = _ref16.beforeChange,
      beforeChange = _ref16$beforeChange === undefined ? function () {} : _ref16$beforeChange,
      _ref16$afterChange = _ref16.afterChange,
      afterChange = _ref16$afterChange === undefined ? function () {} : _ref16$afterChange,
      _ref16$animation = _ref16.animation,
      animation = _ref16$animation === undefined ? 1000 : _ref16$animation,
      _ref16$wheelBool = _ref16.wheelBool,
      wheelBool = _ref16$wheelBool === undefined ? false : _ref16$wheelBool,
      _ref16$keyBool = _ref16.keyBool,
      keyBool = _ref16$keyBool === undefined ? false : _ref16$keyBool,
      _ref16$swipeBool = _ref16.swipeBool,
      swipeBool = _ref16$swipeBool === undefined ? false : _ref16$swipeBool,
      _ref16$intervalBool = _ref16.intervalBool,
      intervalBool = _ref16$intervalBool === undefined ? false : _ref16$intervalBool,
      _ref16$interval = _ref16.interval,
      interval = _ref16$interval === undefined ? 5000 : _ref16$interval,
      _ref16$slideType = _ref16.slideType,
      slideType = _ref16$slideType === undefined ? false : _ref16$slideType,
      _ref16$title = _ref16.title,
      title = _ref16$title === undefined ? 'Slider' : _ref16$title,
      _ref16$backTitle = _ref16.backTitle,
      backTitle = _ref16$backTitle === undefined ? 'Back' : _ref16$backTitle,
      _ref16$changeTitle = _ref16.changeTitle,
      changeTitle = _ref16$changeTitle === undefined ? true : _ref16$changeTitle,
      _ref16$ignoreDeny = _ref16.ignoreDeny,
      ignoreDeny = _ref16$ignoreDeny === undefined ? false : _ref16$ignoreDeny,
      _ref16$onSlideTypeSho = _ref16.onSlideTypeShown,
      onSlideTypeShown = _ref16$onSlideTypeSho === undefined ? function () {} : _ref16$onSlideTypeSho,
      _ref16$onSlideTypeHid = _ref16.onSlideTypeHidden,
      onSlideTypeHidden = _ref16$onSlideTypeHid === undefined ? function () {} : _ref16$onSlideTypeHid;

    // default
    const outer = document.querySelector(selector);
    if (outer === null) return false;
    outer.classList.add('v-slider');

    let deny = false,
      active = 0,
      prevActive = 0,
      count = 0,
      slides = outer.querySelectorAll(".item-v-slider"),
      titles = [],
      radioControlsArray = [],
      textControlsArray = [],
      firstChanging = true,
      shownOuter = false,
      intervalFunc = false,
      intervalFuncEnabled = intervalBool;

    // count
    count = slides.length;
    if (count === 1) {
      outer.classList.add('one-item');
    }
    if (count === 0) return false;

    // items outers
    const wrapper = document.createElement("div");
    wrapper.classList.add("wrapper-v-slider");
    const desk = document.createElement("div");
    desk.classList.add("desk-v-slider");
    const row = document.createElement("div");
    row.classList.add("row-v-slider");
    desk.appendChild(row);
    outer.appendChild(wrapper);

    // back
    if (slideType == true) {
      const backBlock = document.createElement("div");
      backBlock.classList.add("back-v-slider");
      backBlock.innerHTML = backTitle;
      backBlock.onclick = showHideWrapper.bind(this, false, 300);
      showHideWrapper(false, 0);
      wrapper.appendChild(backBlock);
    } else {
      outer.classList.add("full");
    }

    // title
    const titleBlock = document.createElement("div");
    titleBlock.classList.add("title-v-slider");
    titleBlock.innerHTML = title;
    wrapper.appendChild(titleBlock);

    // slides
    let currentTitle = void 0;
    for (let i = 0; i < slides.length; i++) {
      currentTitle = slides[i].getAttribute("data-title");
      if (currentTitle == null) currentTitle = 'Slide';
      titles.push(currentTitle);
      row.appendChild(slides[i]);
      slides[i].style.transition = `${  animation / 1000  }s`;
    }
    desk.appendChild(row);
    wrapper.appendChild(desk);

    // radio controls
    const radioControls = document.createElement("ul");
    radioControls.classList.add("radio-controls-v-slider");
    let li = void 0;
    for (let _i13 = 0; _i13 < slides.length; _i13++) {
      slides[_i13].classList.add(`slide-${  _i13}`);
      li = document.createElement("li");
      li.onclick = setActive.bind(this, _i13, 'radio');
      radioControls.appendChild(li);
      radioControlsArray.push(li);
    }
    desk.appendChild(radioControls);

    // clear
    const clear = document.createElement("div");
    clear.classList.add("clear");
    outer.appendChild(clear);

    // text controls
    const textControls = document.createElement("ul");
    textControls.classList.add("text-controls-v-slider");
    let liCounter = void 0;
    for (let _i14 = 0; _i14 < slides.length; _i14++) {
      if (_i14 < 9) {
        liCounter = `0${  _i14 + 1}`;
      } else {
        liCounter = _i14 + 1;
      }
      li = document.createElement("li");
      li.classList.add("text-controls-v-slider-li");
      li.classList.add(`text-controls-${  _i14}`);
      if (textControlsContent === true) {
        li.innerHTML = `<span class="counter-v-slider">${  liCounter  }</span><div class="content-v-slider">${  slides[_i14].innerHTML  }</div><div class="text text-item-v-slider text-controls-item-${  _i14  }">${  titles[_i14]  }</div>`;
      } else {
        li.innerHTML = `<span class="counter-v-slider">${  liCounter  }</span><div class="content-v-slider"></div><div class="text text-item-v-slider text-controls-item-${  _i14  }">${  titles[_i14]  }</div>`;
      }
      li.onclick = setActive.bind(this, _i14, 'text');
      textControls.appendChild(li);
      textControlsArray.push(li);
    }
    outer.appendChild(textControls);

    // prev button
    const prevButton = document.createElement("button");
    prevButton.innerText = prevText;
    prevButton.onclick = prev.bind(this);
    prevButton.classList.add("control-button-v-slider");
    prevButton.classList.add("prev-v-slider");
    desk.appendChild(prevButton);

    // next button
    const nextButton = document.createElement("button");
    nextButton.innerText = nextText;
    nextButton.onclick = next.bind(this);
    nextButton.classList.add("control-button-v-slider");
    nextButton.classList.add("next-v-slider");
    desk.appendChild(nextButton);

    // set active
    function setActive(num, type) {

      // define type

      if (type === 'radio') {
        if (active === num) {
          return false;
        }
      }
      if (type === 'interval') {
        console.log(`interval${  new Date()}`);
      }

      // deny - continue

      if (deny === true & ignoreDeny !== true) return false;
      deny = true;
      setTimeout(() => {
        deny = false;
      }, animation);

      let continueInterval = false;
      if (type !== 'interval' & intervalFuncEnabled === true) {
        clearIntervalFunc();
        continueInterval = true;
      }

      // callbacks

      if (firstChanging !== true) {
        beforeChange(outer, active, num);
      }

      setTimeout(() => {
        if (firstChanging !== true) {
          afterChange(outer, num, active);
        }
        if (type !== 'interval' & firstChanging !== true) {
          if (continueInterval === true) {
            setIntervalFunc();
          }
        }
      }, animation);

      active = num;

      // animation

      for (let i = 0; i < slides.length; i++) {
        slides[i].classList.remove("active");
        radioControlsArray[i].classList.remove("active");
        textControlsArray[i].classList.remove("active");
      }

      slides[num].classList.add("active");
      radioControlsArray[num].classList.add("active");
      textControlsArray[num].classList.add("active");

      if (slideType == true & firstChanging !== true) {
        showHideWrapper(true, 300);
      }

      if (changeTitle == true) titleBlock.innerHTML = titles[num];

      if (firstChanging == true) firstChanging = false;
    }

    // prev
    function prev(type) {

      active -= 1;

      if (active < 0) {
        active = count - 1;
      }

      if (type !== 'interval') {
        type = 'prev';
      }

      setActive(active, type);
    }

    // next
    function next(type) {

      active += 1;

      if (active > count - 1) {
        active = 0;
      }

      if (type !== 'interval') {
        type = 'next';
      }

      setActive(active, type);
    }

    // get active
    function getActive() {
      return active;
    }

    // showHide wrapper
    function showHideWrapper(bool, anim) {

      if (bool) {
        $(wrapper).stop().slideDown(anim);
        shownOuter = true;
        onSlideTypeShown();
      } else {
        $(wrapper).stop().slideUp(anim);
        shownOuter = false;
        onSlideTypeHidden();
      }
    }

    // showHide wrapper

    function setIntervalFunc() {
      intervalFunc = setInterval(next.bind(this, 'interval'), interval);
      intervalFuncEnabled = true;
      console.info("SETINTERVAL");
    }

    function clearIntervalFunc() {
      clearInterval(intervalFunc);
      intervalFuncEnabled = false;
      console.info("CLEARED");
    }

    if (intervalBool === true) {
      intervalBool = true;
      setIntervalFunc();
    }

    // scroll event

    let timeStamp = new Date().getTime(),
      deltaY = 0.5;

    $(outer).bind('wheel', (e) => {

      // check scroll

      let timeNow = new Date().getTime();

      if (timeNow - timeStamp < 100) {
        timeStamp = timeNow;
        return;
      }
      timeStamp = timeNow;


      // do scroll

      if (wheelBool == true) {

        e.preventDefault();

        // Down
        if (e.originalEvent.deltaY > 0 & e.originalEvent.deltaY > deltaY) {
          next();
        }

        // Up
        if (e.originalEvent.deltaY < 0 & e.originalEvent.deltaY < deltaY * -1) {
          prev();
        }
      }
    });

    // keyboard event

    window.addEventListener("keydown", (e) => {
      if (keyBool !== true & (e.which == 37 || e.which == 39)) return false;
      if (e.which == 39) {
        next();
      }
      if (e.which == 37) {
        prev();
      }
    });

    // Swipe

    let touchXStart = 0,
      swipeK = 50;

    // touchstart
    outer.addEventListener("touchstart", (e) => {
      touchXStart = e.targetTouches[0].pageX;
    });

    // touchend
    outer.addEventListener("touchend", (e) => {
      if (swipeBool == true) {
        const touchX = e.changedTouches[0].pageX;
        if (touchX < touchXStart) {
          if (touchXStart > touchX + swipeK) next();
        } else if (touchX > touchXStart) {
          if (touchX > touchXStart + swipeK) prev();
        }
      }
    });

    setActive(active, 'default');

    // return
    return {
      getActive,
      slides,
      prev,
      next,
      setActive,
      setIntervalFunc,
      clearIntervalFunc
    };
  };

  // FAQ

  v.faq = function () {
    let _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#faq",
        animation: 500
      },
      _ref17$selector = _ref17.selector,
      selector = _ref17$selector === undefined ? "#faq" : _ref17$selector,
      _ref17$animation = _ref17.animation,
      animation = _ref17$animation === undefined ? 500 : _ref17$animation;

    const outer = document.querySelector(selector);
    if (outer === null) return false;
    outer.classList.add("v-faq");

    let items = document.querySelectorAll(`${selector  } > .item`),
      question = null,
      answer = null,
      questionArray = [],
      answerArray = [],
      current = null;

    for (let i = 0; i < items.length; i++) {
      question = items[i].querySelector(".question");
      questionArray.push(question);
      question.onclick = openClose.bind(this, i);
      answer = items[i].querySelector(".answer");
      answerArray.push(answer);
      items[i].setAttribute("data-v-faq", "true");
    }

    // open close

    function openClose() {
      const num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      const anim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : animation;


      if (num > items.length - 1) return;

      for (let _i15 = 0; _i15 < questionArray.length; _i15++) {
        questionArray[_i15].classList.remove("active");
      }

      for (let _i16 = 0; _i16 < answerArray.length; _i16++) {
        answerArray[_i16].classList.remove("active");
        $(answerArray[_i16]).slideUp(anim);
      }

      if (current !== num) {
        questionArray[num].classList.add("active");
        answerArray[num].classList.add("active");
        $(answerArray[num]).slideDown(anim);
        current = num;
      } else {
        current = null;
      }
    }

    // add

    function add() {
      const html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';


      $(outer).append(html);

      items = document.querySelectorAll(`${selector  } > .item`);
      for (let _i17 = 0; _i17 < items.length; _i17++) {
        const attribute = items[_i17].getAttribute("data-v-faq");
        if (attribute !== null) continue;
        question = items[_i17].querySelector(".question");
        questionArray.push(question);
        question.onclick = openClose.bind(this, _i17);
        answer = items[_i17].querySelector(".answer");
        answerArray.push(answer);
        items[_i17].setAttribute("data-v-faq", "true");
      }
    }

    return {
      openClose,
      add
    };
  };

  // Tabs

  v.tabs = function () {
    let _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#v-tabs",
        animation: 125,
        callback: function callback(prev, active) {}
      },
      _ref18$selector = _ref18.selector,
      selector = _ref18$selector === undefined ? "#v-tabs" : _ref18$selector,
      _ref18$animation = _ref18.animation,
      animation = _ref18$animation === undefined ? 125 : _ref18$animation,
      _ref18$callback = _ref18.callback,
      callback = _ref18$callback === undefined ? function (prev, active) {} : _ref18$callback;

    const outer = document.querySelector(selector);
    if (outer === null) return false;
    outer.classList.add("v-tabs");

    let items = document.querySelectorAll(`${selector  } > .v-tabs-item`),
      title = null,
      titleArray = [],
      titleDomArray = [],
      current = null;

    if (items.length === 0) return false;

    for (let i = 0; i < items.length; i++) {
      title = items[i].querySelector(".v-tabs-title");
      if (title !== null) {
        title = title.innerHTML;
      } else {
        title = `Tab ${  i + 1}`;
      }
      titleArray.push(title);
    }

    const titleOuter = document.createElement("div");
    titleOuter.classList.add("v-tabs-title-outer");
    outer.insertBefore(titleOuter, outer.children[0]);
    for (let _i18 = 0; _i18 < titleArray.length; _i18++) {
      const newTitle = document.createElement("div");
      newTitle.classList.add("v-tabs-title-outer-item");
      newTitle.innerHTML = titleArray[_i18];
      newTitle.style.width = `${100 / titleArray.length  }%`;
      newTitle.onclick = openClose.bind(this, _i18);
      titleDomArray.push(newTitle);
      titleOuter.appendChild(newTitle);
    }

    // open close

    function openClose() {
      const num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      const anim = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : animation;


      if (num > items.length - 1) return;
      if (current === num) return;

      for (let _i19 = 0; _i19 < items.length; _i19++) {
        items[_i19].classList.remove("active");
        $(items[_i19]).stop().fadeOut(animation);
      }

      for (let _i20 = 0; _i20 < titleDomArray.length; _i20++) {
        titleDomArray[_i20].classList.remove("active");
      }

      items[num].classList.add("active");
      $(items[num]).stop().fadeIn(animation);
      titleDomArray[num].classList.add("active");

      callback(current, num);

      current = num;
    }

    openClose(0, 0);

    return {
      openClose
    };
  };

  // Menu

  v.menuDelayShow = 0;
  v.menuDelayHide = 0;

  v.menu = function () {
    let _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selectorButton: "#menu-button",
        selectorMenu: "#menu-outer",
        animationButton: 500,
        animation: 500,
        animationInnerBool: false,
        animationInner: 500,
        menuLinkBool: false,
        menuLink: '',
        onShow: function onShow() {},
        onHide: function onHide() {}
      },
      _ref19$selectorButton = _ref19.selectorButton,
      selectorButton = _ref19$selectorButton === undefined ? "#menu-button" : _ref19$selectorButton,
      _ref19$selectorMenu = _ref19.selectorMenu,
      selectorMenu = _ref19$selectorMenu === undefined ? "#menu-outer" : _ref19$selectorMenu,
      _ref19$animationButto = _ref19.animationButton,
      animationButton = _ref19$animationButto === undefined ? 500 : _ref19$animationButto,
      _ref19$animation = _ref19.animation,
      animation = _ref19$animation === undefined ? 500 : _ref19$animation,
      _ref19$animationInner = _ref19.animationInnerBool,
      animationInnerBool = _ref19$animationInner === undefined ? false : _ref19$animationInner,
      _ref19$animationInner2 = _ref19.animationInner,
      animationInner = _ref19$animationInner2 === undefined ? 500 : _ref19$animationInner2,
      _ref19$menuLinkBool = _ref19.menuLinkBool,
      menuLinkBool = _ref19$menuLinkBool === undefined ? false : _ref19$menuLinkBool,
      _ref19$menuLink = _ref19.menuLink,
      menuLink = _ref19$menuLink === undefined ? '' : _ref19$menuLink,
      _ref19$onShow = _ref19.onShow,
      onShow = _ref19$onShow === undefined ? function () {} : _ref19$onShow,
      _ref19$onHide = _ref19.onHide,
      onHide = _ref19$onHide === undefined ? function () {} : _ref19$onHide;

    // define

    let shown = false,
      deny = false,
      outerButtonHovered = false,
      forbiddenHover = false;

    let delayShow = 0,
      delayHide = 0;

    const outerButton = document.querySelector(selectorButton);
    if (outerButton === null) return false;
    const outer = document.querySelector(selectorMenu);
    if (outer === null) return false;

    // show hide

    function showHide(e) {

      if (e !== null & e !== undefined) {
        e.preventDefault();
      }

      if (deny == true) {
        return false;
      }

      if (shown == false) {
        const func = function func() {

          document.documentElement.classList.add("menu-opened");
          outer.classList.add("show");

          setTimeout(() => {
            outer.classList.add("prepare-show");
            outerButton.classList.add("forbidden-hover");
          }, 200);

          outerButton.classList.add("close");
          outer.classList.remove("prepare-hide");

          setTimeout(() => {
            shown = true;
            if (animationInnerBool === true) {
              outer.classList.add("animation-show");
              document.documentElement.classList.add("menu-animation-show");
              setTimeout(() => {
                deny = false;
              }, animationInner);
            } else {
              deny = false;
            }
          }, animation);
        };

        forbiddenHover = true;
        onShow();
        deny = true;

        if (v.menuDelayShow === 0) {
          func();
        } else {
          setTimeout(func.bind(this), v.menuDelayShow);
        }
      } else {
        const _func = function _func() {

          if (animationInnerBool === true) {
            outer.classList.remove("animation-show");
            document.documentElement.classList.remove("menu-animation-show");
          }

          function funcInner() {

            shown = false;

            document.documentElement.classList.remove("menu-opened");
            outerButton.classList.remove("close");
            outer.classList.add("prepare-hide");
            outer.classList.remove("prepare-show");

            setTimeout(() => {
              outer.classList.remove("show");
              deny = false;
            }, animation);

            setTimeout(() => {
              if (outerButtonHovered == true) {
                $(outerButton).one("mouseleave", () => {
                  if (forbiddenHover == false) {
                    outerButton.classList.remove("forbidden-hover");
                  }
                });
              } else {
                outerButton.classList.remove("forbidden-hover");
              }
            }, animationButton);
          }

          if (animationInnerBool === true) {
            setTimeout(funcInner.bind(this), animationInner);
          } else {
            funcInner();
          }
        };

        forbiddenHover = false;
        onHide();
        deny = true;

        if (v.menuDelayHide === 0) {
          _func();
        } else {
          setTimeout(_func.bind(this), v.menuDelayHide);
        }
      }
    }

    // hide

    function hide(e) {
      if (shown == true & e.keyCode == 27) {
        showHide(null);
      }
    }

    // events

    function events() {

      outerButton.onclick = showHide.bind(this);
      document.body.onkeydown = hide.bind(this);
      const overlay = outer.querySelector(".overlay");
      if (overlay !== null) {
        overlay.onclick = showHide.bind(this, null);
      }
      outerButton.onmouseover = function () {
        outerButtonHovered = true;
      };
      outerButton.onmouseleave = function () {
        outerButtonHovered = false;
      };

      outerButton.addEventListener("mouseover", () => {
        if (v.viewportWidth[1] <= v.properties.tablet) return;
        outerButton.setAttribute("data-hovered", true);
        setTimeout(() => {
          if (outerButton.getAttribute("data-hovered") !== null) {
            if (!shown) {
              showHide();
            }
          }
        }, 400);
      });

      outerButton.addEventListener("mouseleave", () => {
        outerButton.removeAttribute("data-hovered");
      });
    }

    // run

    function run() {
      if (menuLinkBool !== true) {
        events();
      } else {
        outerButton.classList.add("close");
        outerButton.classList.add("forbidden-hover");
        outerButton.href = menuLink;
      }
    }

    // change properties

    function changeProperties() {
      const properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


      for (const prop in properties) {
        eval(`${prop  } = ${  properties[prop]  };`);
      }
    }

    run();

    v.consoleInfo(`Using menu for: ${  outer}`);

    return {
      showHide,
      opened() {
        return shown;
      },
      changeProperties
    };
  };

  // Same Height

  v.sameHeight = function () {
    let _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: ".items"
      },
      _ref20$selector = _ref20.selector,
      selector = _ref20$selector === undefined ? ".items" : _ref20$selector;

    // clear height

    function clearHeight() {
      const items = document.querySelectorAll(selector);
      for (let i = 0; i < items.length; i++) {
        items[i].style.height = '';
      }
    }

    // set height

    function setHeight() {
      let items = document.querySelectorAll(selector),
        max = 0;
      for (let i = 0; i < items.length; i++) {
        items[i].style.height = '';
        const itemHeight = items[i].clientHeight;
        if (itemHeight > max) max = itemHeight;
      }
      for (let _i21 = 0; _i21 < items.length; _i21++) {
        items[_i21].style.height = `${max  }px`;
      }
    }

    return {
      clearHeight,
      setHeight
    };
  };

  // Lazy Images

  v.lazy = function () {
    let _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: ".lazy",
        outerSelector: "#wrap", // selector string or window
        percentPosition: 150,
        runOnInit: true
      },
      _ref21$selector = _ref21.selector,
      selector = _ref21$selector === undefined ? ".lazy" : _ref21$selector,
      _ref21$outerSelector = _ref21.outerSelector,
      outerSelector = _ref21$outerSelector === undefined ? "#wrap" : _ref21$outerSelector,
      _ref21$percentPositio = _ref21.percentPosition,
      percentPosition = _ref21$percentPositio === undefined ? 150 : _ref21$percentPositio,
      _ref21$runOnInit = _ref21.runOnInit,
      runOnInit = _ref21$runOnInit === undefined ? true : _ref21$runOnInit;

    let obj = {},
      outer = false;

    function update() {

      for (const prop in obj) {
        const item = obj[prop];
        if (!item) continue;
        const bounding = item.getBoundingClientRect();
        if (bounding.top <= v.viewportHeight[1] * percentPosition / 100) {
          item.setAttribute("data-v-lazy-done", "true");
          item.style.backgroundImage = `url('${  item.getAttribute("data-src")  }')`;
          item.removeAttribute("data-src");
          delete obj[prop];
        }
      }
    }

    function add() {

      const items = document.querySelectorAll(selector);
      for (let i = 0; i < items.length; i++) {
        if (items[i].getAttribute("data-src") !== null & items[i].getAttribute("data-v-lazy-done") === null) {
          let further = false;
          if (items[i].getAttribute("data-v-lazy") !== null) {
            let itemContains = false;
            for (const prop in obj) {
              const item = obj[prop];
              if (items[i] === item) {
                itemContains = true;
              }
            }
            if (itemContains === false) {
              further = true;
            }
          } else {
            further = true;
          }
          if (further === true) {
            const id = v.randInt({
              min: 100,
              max: 9999
            }) * v.randInt({
              min: 100,
              max: 9999
            });
            obj[`object-${  id}`] = items[i];
            items[i].setAttribute("data-v-lazy", id);
          }
        }
      }

      update();
    }

    function clear() {

      obj = {};
      add();
    }

    if (outerSelector !== window) {
      outer = document.querySelector(outerSelector);
    } else {
      outer = window;
    }

    if (outer === null) {
      return false;
    }

    outer.addEventListener("scroll", update.bind(this));
    if (runOnInit === true) add();

    v.consoleInfo(`Using lazy for: ${  obj}`);

    return {
      add,
      update,
      clear,
      getObj() {
        return obj;
      }
    };
  };

  // Filter

  v.filter = function () {
    let _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        updateAfterChange: true,
        updateTitle: true,
        updateCount: true,
        removeAtive: true,
        markers: true,
        markersSelector: '.v-filter-markers',
        setOnStart: true,
        callbackChange: function callbackChange(e) {},
        callbackSave: function callbackSave() {},
        callbackSet: function callbackSet() {},
        callbackReset: function callbackReset() {}
      },
      _ref22$updateAfterCha = _ref22.updateAfterChange,
      updateAfterChange = _ref22$updateAfterCha === undefined ? true : _ref22$updateAfterCha,
      _ref22$updateTitle = _ref22.updateTitle,
      updateTitle = _ref22$updateTitle === undefined ? true : _ref22$updateTitle,
      _ref22$updateCount = _ref22.updateCount,
      updateCount = _ref22$updateCount === undefined ? true : _ref22$updateCount,
      _ref22$removeAtive = _ref22.removeAtive,
      removeAtive = _ref22$removeAtive === undefined ? true : _ref22$removeAtive,
      _ref22$markers = _ref22.markers,
      markers = _ref22$markers === undefined ? true : _ref22$markers,
      _ref22$markersSelecto = _ref22.markersSelector,
      markersSelector = _ref22$markersSelecto === undefined ? '.v-filter-markers' : _ref22$markersSelecto,
      _ref22$setOnStart = _ref22.setOnStart,
      setOnStart = _ref22$setOnStart === undefined ? true : _ref22$setOnStart,
      _ref22$callbackChange = _ref22.callbackChange,
      callbackChange = _ref22$callbackChange === undefined ? function (e) {} : _ref22$callbackChange,
      _ref22$callbackSave = _ref22.callbackSave,
      callbackSave = _ref22$callbackSave === undefined ? function () {} : _ref22$callbackSave,
      _ref22$callbackSet = _ref22.callbackSet,
      callbackSet = _ref22$callbackSet === undefined ? function () {} : _ref22$callbackSet,
      _ref22$callbackReset = _ref22.callbackReset,
      callbackReset = _ref22$callbackReset === undefined ? function () {} : _ref22$callbackReset;

    // vars

    let dataFilter = 'data-v-filter',
      dataId = 'data-v-filter-id',
      dataValue = 'data-v-filter-value',
      dataProceeded = 'data-v-filter-proceeded',
      dataCount = 'data-v-filter-count',
      classActive = 'active',
      classDisabled = 'disabled',
      splitter = '||',
      titles = {},
      titlesValues = {},
      items = [],
      ids = [],
      values = [],
      markersOuter = null,
      denyChange = false,
      countDenyChange = 0;

    // set title

    function setTitle() {

      for (let i = 0; i < ids.length; i++) {

        if (titles[ids[i]] !== undefined) {
          if (titles[ids[i]].length > 0) {

            let newTitle = '';
            for (let a = 0; a < values.length; a++) {
              if (values[a].getAttribute(dataId) == ids[i] & values[a].getAttribute(dataValue) !== null) {
                if (values[a].classList.contains(classActive)) {
                  let newValue = values[a].innerHTML;
                  if (values[a].querySelector("a") !== null) {
                    newValue = values[a].querySelector("a").innerHTML;
                  }
                  newTitle += `, ${  newValue}`;
                }
              }
            }

            for (let _a = 0; _a < titles[ids[i]].length; _a++) {
              if (newTitle == '') {
                titles[ids[i]][_a].innerHTML = titlesValues[ids[i]][_a];
              } else if (updateTitle === true) {
                titles[ids[i]][_a].innerHTML = newTitle.substring(2);
              } else {
                titles[ids[i]][_a].innerHTML = titlesValues[ids[i]][_a];
              }
            }
          }
        }
      }
    }

    // set markers

    function setMarkers() {

      if (markersOuter === null || markers !== true) return false;

      markersOuter.innerHTML = '';

      for (let i = 0; i < ids.length; i++) {
        const createMarker = function createMarker(html, link) {
          const element = document.createElement("div");
          element.classList.add("v-filter-marker");
          element.innerHTML = `<div class="outer">${  html  }<div class="close"></div></div>`;
          element.onclick = function () {
            $(link).click();
            if (updateAfterChange !== true) {
              save();
            }
          };
          return element;
        };

        for (let a = 0; a < values.length; a++) {
          if (values[a].getAttribute(dataId) == ids[i] & values[a].getAttribute(dataValue) !== null) {
            if (values[a].classList.contains(classActive)) {
              let link = values[a].querySelector("a");
              if (link === null) {
                link = values[a];
              }
              const newValue = link.innerHTML;
              const marker = createMarker(newValue, link);
              markersOuter.appendChild(marker);
            }
          }
        }

        if (markersOuter.children.length > 0) {
          markersOuter.classList.remove("display-none");
        } else {
          markersOuter.classList.add("display-none");
        }
      }
    }

    // set count

    function setCount() {

      if (updateCount !== true) return false;
      denyChange = true;

      // get array of values

      const currentValues = [];

      for (let i = 0; i < ids.length; i++) {

        const idsValue = [];

        // values

        for (let a = 0; a < values.length; a++) {
          if (values[a].getAttribute(dataId) == ids[i] & values[a].getAttribute(dataValue) !== null) {
            if (values[a].classList.contains(classActive)) {
              idsValue.push(values[a].getAttribute(dataValue));
            }
          }
        }
        // set value

        let getValue = '';
        for (let _a2 = 0; _a2 < idsValue.length; _a2++) {
          getValue += splitter + idsValue[_a2];
        }
        if (getValue.length > 0) {
          getValue = getValue.substr(splitter.length);
        }

        currentValues.push([ids[i], getValue]);
      }

      for (let _i22 = 0; _i22 < ids.length; _i22++) {

        const currentArrayValues = [];
        for (let _a3 = 0; _a3 < currentValues.length; _a3++) {
          if (currentValues[_a3][0] == ids[_i22]) continue;
          currentArrayValues.push(currentValues[_a3]);
        }

        const currentPost = $.post(window.location.href, {
          get: ids[_i22],
          values: JSON.stringify(currentArrayValues)
        }, callback.bind(this, ids[_i22])).fail(() => {
          setCount();
        });

        setTimeout(((p) => {
          p.abort();
        }).bind(this, currentPost), v.ajaxMaxTime);
      }

      function callback(id, data) {
        const results = data.split(" || ");
        for (let _i23 = 0; _i23 < values.length; _i23++) {
          if (values[_i23].getAttribute(dataId) == id & values[_i23].getAttribute(dataValue) !== null) {
            for (let _a4 = 0; _a4 < results.length; _a4++) {
              const resultsSplit = results[_a4].split(" ");
              if (values[_i23].getAttribute(dataValue) == resultsSplit[0]) {
                if (parseInt(resultsSplit[1]) > 0) {
                  values[_i23].classList.remove(classDisabled);
                } else {
                  values[_i23].classList.add(classDisabled);
                }
              }
            }
          }
        }
        countDenyChange++;
        if (countDenyChange >= ids.length) {
          denyChange = false;
          countDenyChange = 0;
        }
      }
    }

    // set

    function set() {

      if (setOnStart === true) {
        for (let i = 0; i < values.length; i++) {
          if (v.getParameter({
              name: values[i].getAttribute(dataId)
            }) !== null) {
            const getString = v.getParameter({
              name: values[i].getAttribute(dataId)
            }).split(splitter);
            if (getString.includes(values[i].getAttribute(dataValue))) {
              values[i].classList.add(classActive);
            } else {
              values[i].classList.remove(classActive);
            }
          } else {
            values[i].classList.remove(classActive);
          }
        }
      }

      setTitle();
      setMarkers();
      callbackSet();
    }

    // reset

    function reset() {

      for (let i = 0; i < ids.length; i++) {

        for (let a = 0; a < values.length; a++) {
          if (values[a].getAttribute(dataId) == ids[i] & values[a].getAttribute(dataValue) !== null) {
            if (values[a].classList.contains(classActive)) {
              values[a].classList.remove(classActive);
            }
          }
        }
      }

      callbackReset();
      save();
    }

    // save

    function save() {

      for (let i = 0; i < ids.length; i++) {

        const idsValue = [];

        // values

        for (let a = 0; a < values.length; a++) {
          if (values[a].getAttribute(dataId) == ids[i] & values[a].getAttribute(dataValue) !== null) {
            if (values[a].classList.contains(classActive)) {
              idsValue.push(values[a].getAttribute(dataValue));
            }
          }
        }

        // set value

        let getValue = '',
          setValue = true;
        for (let _a5 = 0; _a5 < idsValue.length; _a5++) {
          getValue += splitter + idsValue[_a5];
        }
        if (getValue.length <= 0) {
          setValue = false;
          if (v.getParameter({
              name: ids[i]
            }) !== null) {
            setValue = true;
          }
        } else {
          getValue = getValue.substr(splitter.length);
        }
        if (setValue === true) {
          v.setParameter({
            name: ids[i],
            value: getValue
          });
        }
      }

      setTitle();
      setMarkers();
      callbackSave();
    }

    // events

    function events() {

      for (let i = 0; i < ids.length; i++) {
        const valuesArray = document.querySelectorAll(`*[${  dataFilter  }="value"][${  dataId  }="${  ids[i]  }"]`);
        for (let a = 0; a < valuesArray.length; a++) {
          if (valuesArray[a].getAttribute(dataProceeded) !== null) continue;
          valuesArray[a].setAttribute(dataProceeded, true);
          values.push(valuesArray[a]);
        }
      }

      for (let _i24 = 0; _i24 < values.length; _i24++) {

        let link = values[_i24].querySelector("a");
        if (link === null) {
          link = values[_i24];
        }

        link.onclick = function (element) {
          const e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


          if (e !== null) e.preventDefault();

          if (denyChange === true & updateCount === true) return false;

          if (element.classList.contains(classDisabled) & !element.classList.contains(classActive)) return false;

          if (element.classList.contains(classActive) & removeAtive !== true) return false;

          /* Count */
          let outer = null;
          for (let _i25 = 0; _i25 < items.length; _i25++) {
            if (items[_i25].getAttribute(dataId) == element.getAttribute(dataId)) {
              outer = items[_i25];
            }
          }
          if (outer.getAttribute(dataCount) !== null) {
            for (let _i26 = 0; _i26 < values.length; _i26++) {
              if (values[_i26].getAttribute(dataId) == element.getAttribute(dataId) & values[_i26].getAttribute(dataValue) != element.getAttribute(dataValue)) {
                values[_i26].classList.remove(classActive);
              }
            }
          }
          /* Count */

          if (element.classList.contains(classActive)) {
            element.classList.remove(classActive);
          } else {
            element.classList.add(classActive);
          }

          setTitle();
          setTimeout(setCount.bind(this), v.timeMin);
          callbackChange(element);

          if (updateAfterChange === true) {
            save();
          }
        }.bind(this, values[_i24]);
      }
    }

    // init

    function add() {

      const idArray = document.querySelectorAll(`*[${  dataFilter  }="item"]`);

      const itemsArray = document.querySelectorAll(`*[${  dataFilter  }="item"]`);
      if (itemsArray.length <= 0) {
        v.consoleError(`There's no V Filter with data attribute: ${  dataFilter}`);
        return;
      }

      for (let i = 0; i < itemsArray.length; i++) {
        if (itemsArray[i].getAttribute(dataId) === null) {
          v.consoleError(`There's no V Filter Id in: ${  itemsArray[i]}`);
          return;
        }
        if (itemsArray[i].getAttribute(dataProceeded) !== null) continue;
        itemsArray[i].setAttribute(dataProceeded, true);
        items.push(itemsArray[i]);
        ids.push(itemsArray[i].getAttribute(dataId));
        const title = document.querySelectorAll(`*[${  dataFilter  }="title"][${  dataId  }="${  itemsArray[i].getAttribute(dataId)  }"]`);
        if (title.length > 0) {
          titles[itemsArray[i].getAttribute(dataId)] = [];
          titlesValues[itemsArray[i].getAttribute(dataId)] = [];
          for (let a = 0; a < title.length; a++) {
            titles[itemsArray[i].getAttribute(dataId)][a] = title[a];
            titlesValues[itemsArray[i].getAttribute(dataId)][a] = title[a].innerHTML;
          }
        }

      }

      markersOuter = document.querySelector(markersSelector);

      events();
    }

    add();
    set();

    return {
      add,
      events,
      save,
      set,
      reset,
      setTitle,
      setMarkers,
      setCount
    };
  };

  // Add Clear

  v.addClear = function () {
    let _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selectorOuter: "#items",
        itemClass: "item",
        count: 4
      },
      _ref23$selectorOuter = _ref23.selectorOuter,
      selectorOuter = _ref23$selectorOuter === undefined ? "#items" : _ref23$selectorOuter,
      _ref23$itemClass = _ref23.itemClass,
      itemClass = _ref23$itemClass === undefined ? "item" : _ref23$itemClass,
      _ref23$count = _ref23.count,
      count = _ref23$count === undefined ? 4 : _ref23$count;

    const outer = document.querySelector(selectorOuter);
    if (outer === null) {
      v.consoleError(`There's no DOM object: ${  selectorOuter}`);
      return false;
    }
    if (!Number.isInteger(count)) {
      v.consoleError(`${count  } is not integer`);
      return false;
    }

    let children = outer.children;
    for (let i = 0; i < children.length; i++) {
      if (!children[i].classList.contains(itemClass)) {
        outer.removeChild(children[i]);
      }
    }
    children = outer.children;

    for (let _i27 = 0, a = 0, first = true; _i27 < children.length; _i27++) {
      a++;
      if (a === count & first === true) {
        $("<div class='clear'></div>").insertAfter(children[_i27]);
        a = 0;
        if (first === true) {
          first = false;
        }
      }
      if (a === count + 1 & first !== true) {
        $("<div class='clear'></div>").insertAfter(children[_i27]);
        a = 0;
      }
    }
  };
  v.canvasSlider = function () {
    let _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#v-canvas-slider",
        active: 0,
        animation: 500,
        parallax: .05,
        controls: .1,
        controlsOnFirst: true,
        controlsAnimation: 250,
        controlsAnimationDelay: 1000,
        keydown: true,
        swipe: true,
        wheel: true,
        intervalBool: false,
        interval: 5000,
        before: function before() {},
        after: function after() {}
      },
      _ref24$selector = _ref24.selector,
      selector = _ref24$selector === undefined ? "#v-canvas-slider" : _ref24$selector,
      _ref24$active = _ref24.active,
      active = _ref24$active === undefined ? 0 : _ref24$active,
      _ref24$animation = _ref24.animation,
      animation = _ref24$animation === undefined ? 500 : _ref24$animation,
      _ref24$parallax = _ref24.parallax,
      parallax = _ref24$parallax === undefined ? .05 : _ref24$parallax,
      _ref24$controls = _ref24.controls,
      controls = _ref24$controls === undefined ? .1 : _ref24$controls,
      _ref24$controlsOnFirs = _ref24.controlsOnFirst,
      controlsOnFirst = _ref24$controlsOnFirs === undefined ? true : _ref24$controlsOnFirs,
      _ref24$controlsAnimat = _ref24.controlsAnimation,
      controlsAnimation = _ref24$controlsAnimat === undefined ? 250 : _ref24$controlsAnimat,
      _ref24$controlsAnimat2 = _ref24.controlsAnimationDelay,
      controlsAnimationDelay = _ref24$controlsAnimat2 === undefined ? 1000 : _ref24$controlsAnimat2,
      _ref24$keydown = _ref24.keydown,
      keydown = _ref24$keydown === undefined ? true : _ref24$keydown,
      _ref24$swipe = _ref24.swipe,
      swipe = _ref24$swipe === undefined ? true : _ref24$swipe,
      _ref24$wheel = _ref24.wheel,
      wheel = _ref24$wheel === undefined ? true : _ref24$wheel,
      _ref24$intervalBool = _ref24.intervalBool,
      intervalBool = _ref24$intervalBool === undefined ? false : _ref24$intervalBool,
      _ref24$interval = _ref24.interval,
      interval = _ref24$interval === undefined ? 5000 : _ref24$interval,
      _ref24$before = _ref24.before,
      before = _ref24$before === undefined ? function () {} : _ref24$before,
      _ref24$after = _ref24.after,
      after = _ref24$after === undefined ? function () {} : _ref24$after;

    // define

    let outer = false,
      images = [],
      imagesLoaded = 0,
      count = 0,
      canvas = [],
      ctx = [],
      width = 0,
      height = 0,
      controlsProgress = 0,
      controlsTimeout = null,
      controlsInterval = null,
      controlsAnimationBool = false,
      eventAnimation = false,
      intervalFunc = false,
      intervalFuncEnabled = intervalBool,
      nextButton = false,
      navUl = false,
      navUlLi = [],
      firstStart = true;

    // init

    function init() {

      // check

      outer = document.querySelector(selector);
      if (outer === null) {
        v.consoleError(`canvasSelector: There's no such an element "${  selector  }"`);
        return false;
      }

      canvas = outer.querySelectorAll("canvas");
      if (canvas.length < 3) {
        v.consoleError(`canvasSelector: There's no 3 canvas in "${  outer  }"`);
        return false;
      }
      ctx[0] = canvas[0].getContext('2d');
      ctx[1] = canvas[1].getContext('2d');
      ctx[2] = canvas[2].getContext('2d');




      // next button

      nextButton = document.createElement("div");
      nextButton.classList.add("control");
      nextButton.classList.add("next");
      nextButton.innerHTML = '';
      outer.insertBefore(nextButton, canvas[1]);

      sizes();

      const ul = outer.querySelector("ul");
      if (ul === null) {
        v.consoleError(`canvasSelector: There's no ul in "${  outer  }"`);
        return false;
      }

      const children = ul.querySelectorAll("li");
      if (children.length === 0) {
        v.consoleError(`canvasSelector: There's no li in "${  ul  }"`);
        return false;
      }

      for (let i = 0; i < children.length; i++) {
        let image = children[i].querySelector("img");

        if (image === null) {
          v.consoleError(`canvasSelector: There's no img in "${  children[i]  }"`);
          return false;
        }
        const src = image.getAttribute("src");
        if (src === null || src.length === 0) {
          v.consoleError(`canvasSelector: Wrong src in "${  image  }"`);
          return false;
        }
        image = new Image();

        image.addEventListener('load', () => {
          imagesLoaded++;
          setStart(active);
        }, false);
        image.src = src;

        images.push(image);
      }

      count = images.length;

      // nav

      navUl = document.createElement("ul");
      navUl.classList.add("nav");
      outer.appendChild(navUl);
      for (let _i28 = 0; _i28 < count; _i28++) {
        const li = document.createElement("li");
        navUl.appendChild(li);
        navUlLi.push(li);
        li.onclick = set.bind(this, _i28);
      }
    }

    // sizes

    function sizes() {

      width = outer.clientWidth;
      height = outer.clientHeight;

      for (let i = 0; i < canvas.length; i++) {
        canvas[i].width = width;
        canvas[i].height = height;


      }
    }

    // animate

    function animate(duration, callback) {
      const percent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;



      const startedAt = Date.now();

      const func = function func() {

        let progress = (Date.now() - startedAt) / duration;
        let progressOutput = percent + (1 - percent) * progress;

        if (progress >= 1) {
          progress = 1;
          progressOutput = 1;
        }

        callback(duration, progressOutput, percent);

        if (progress < 1) {
          window.requestAnimationFrame(func);
        }
      };

      window.requestAnimationFrame(func);

      /* let t = setInterval(function(){
            let progress = (Date.now() - startedAt) / duration;
          let progressOutput = percent + ((1-percent) * progress);
            if (progress >= 1){
              clearInterval(t);
              progress = 1;
              progressOutput = 1;
          }
            callback(duration, progressOutput, percent);
        }, (duration / (duration / 1000 * 60))); */
    };

    function animateControls(duration, callback) {
      const percent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;


      const startedAt = Date.now();
      controlsAnimationBool = true;

      const func = function func() {

        let progress = (Date.now() - startedAt) / duration;
        let progressOutput = percent + (1 - percent) * progress;

        if (progress >= 1) {
          progress = 1;
          progressOutput = 1;
        }

        callback(duration, progressOutput, percent);

        if (progress < 1) {
          if (controlsAnimationBool === true) {
            window.requestAnimationFrame(func);
          } else {
            controlsProgress = 0;
          }
        }

        return {
          t: true
        };
      };

      window.requestAnimationFrame(func);
    };

    // image size

    function imageSize(_ref25) {
      const img = _ref25.img;


      let imageWidth = width,
        imageHeight = img.height * imageWidth / img.width,
        x = 0,
        y = (height - imageHeight) / 2;

      if (imageHeight < height) {
        imageHeight = height;
        imageWidth = img.width * imageHeight / img.height;
        x = (width - imageWidth) / 2;
        y = 0;
      }

      return {
        img,
        imageWidth,
        imageHeight,
        x,
        y
      };
    }

    // set start

    function setStart(num) {

      if (imagesLoaded !== count) return false;

      // active

      active = num;

      ctx[0].clearRect(0, 0, width, height);

      const activeImageSize = imageSize({
        img: images[num]
      });


      ctx[0].drawImage(images[num], 0, 0, images[num].width, images[num].height, activeImageSize.x, activeImageSize.y, activeImageSize.imageWidth, activeImageSize.imageHeight);

      // next

      ctx[1].save();
      ctx[1].beginPath();
      ctx[1].clearRect(0, 0, width, height);


    }

    // set slide

    function set() {
      let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;


      num = parseInt(num);
      if (num < 0) return false;
      if (num > count - 1) return false;

      if (num === active) {
        return false;
      }

      next('', 0, num);
    }

    // update nav

    function updateNav() {

      for (let i = 0; i < navUlLi.length; i++) {
        navUlLi[i].classList.remove("active");
      }

      navUlLi[active].classList.add("active");
    }

    // get next

    function getNext() {
      const num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : active;


      let newActive = num;
      newActive += 1;
      if (newActive > count - 1) {
        newActive = 0;
      }
      return newActive;
    }

    // get prev

    function getPrev() {
      const num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : active;


      let newActive = num;
      newActive -= 1;
      if (newActive < 0) {
        newActive = count - 1;
      }
      return newActive;
    }

    // next

    function next() {
      const type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      let percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      const num = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


      if (eventAnimation === true) return;

      let continueInterval = false;
      if (type !== 'interval' & intervalFuncEnabled === true) {
        clearIntervalFunc();
        continueInterval = true;
      }

      // next (2)

      nextHoverClear();

      eventAnimation = true;

      if (controlsProgress !== 0) {
        percent = controls * controlsProgress;
      }

      // events
      before.call(this, active, num !== null ? num : getNext());

      animate(animation, nextAnimate.bind(this, continueInterval, type, num), percent);

      controlsProgress = 0;
    }

    // next animate

    function nextAnimate(continueInterval, type, num, duration, progress, progressStart) {



      // ative

      ctx[0].save();
      ctx[0].beginPath();

      let img = images[active],
        nextImageSize = imageSize({
          img
        });

      let clipHeight = height,
        top = 0,
        left = 0,
        currentParallax = 0,
        currentPercent = 1 - (1 - progress) / (1 - progressStart);

      currentParallax = currentPercent * height * parallax * -1;

      ctx[0].rect(left, top, width, clipHeight);
      ctx[0].closePath();
      ctx[0].clip();
      ctx[0].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y + currentParallax, nextImageSize.imageWidth, nextImageSize.imageHeight);
      ctx[0].restore();

      // next (1)

      ctx[1].save();
      ctx[1].beginPath();

      img = images[num !== null ? num : getNext()];
      nextImageSize = imageSize({
        img
      });

      clipHeight = height * progress;
      top = height - clipHeight;
      left = 0;
      currentParallax = 0;

      if (progress <= controls) {
        currentParallax = height * parallax;
      } else {
        currentParallax = (1 - progress) / (1 - controls) * height * parallax;
      }

      ctx[1].rect(left, top, width, clipHeight);
      ctx[1].closePath();
      ctx[1].clip();
      ctx[1].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y + currentParallax, nextImageSize.imageWidth, nextImageSize.imageHeight);
      ctx[1].restore();

      if (progress === 1) {

        // events
        after.call(this, active, num !== null ? num : getNext());

        active = num !== null ? num : getNext();
        eventAnimation = false;
        setStart(active);
        if (continueInterval === true) {
          setIntervalFunc();
        }
      }
    }

    // next hover

    function nextHover() {

      controlsInterval = animateControls(controlsAnimation, nextHoverAnimate.bind(this), 0);
    }

    // next hover clear

    function nextHoverClear() {

      if (controlsTimeout !== null) clearTimeout(controlsTimeout);
      controlsTimeout = null;
      if (controlsInterval !== null) {
        controlsAnimationBool = false; // clearInterval(controlsInterval.t);
      }
      controlsInterval = null;
    }

    // next hover animate

    function nextHoverAnimate(duration, progress, progressStart) {

      // next (2)

      controlsProgress = progress;



      let img = images[getNext()],
        nextImageSize = imageSize({
          img
        });

      let clipHeight = height * controls * progress,
        top = height - clipHeight,
        left = 0,
        currentParallax = height * parallax;


    }

    // next hover hide

    function nextHoverHide() {

      controlsInterval = animate(controlsAnimation, nextHoverHideAnimate.bind(this), 1 - controlsProgress);
    }

    // next hover hide animate

    function nextHoverHideAnimate(duration, progress, progressStart) {

      // next (2)

      controlsProgress = 1 - progress;



      let img = images[getNext()],
        nextImageSize = imageSize({
          img
        });

      let clipHeight = height * controls * (1 - progress),
        top = height - clipHeight,
        left = 0,
        currentParallax = height * parallax;


    }

    // prev

    function prev() {
      const type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      const percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      const num = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


      if (eventAnimation === true) return;

      let continueInterval = false;
      if (type !== 'interval' & intervalFuncEnabled === true) {
        clearIntervalFunc();
        continueInterval = true;
      }

      // next (2)

      nextHoverClear();
      if (controlsProgress !== 0) {
        nextHoverHide();
      }

      eventAnimation = true;

      // events
      before.call(this, active, num !== null ? num : getPrev());

      animate(animation, prevAnimate.bind(this, continueInterval, type, num), percent);

      controlsProgress = 0;
    }

    // prev animate

    function prevAnimate(continueInterval, type, num, duration, progress, progressStart) {

      // ative

      ctx[0].save();
      ctx[0].beginPath();

      let img = images[active],
        nextImageSize = imageSize({
          img
        });

      let clipHeight = height,
        top = 0,
        left = 0,
        currentParallax = 0,
        currentPercent = 1 - (1 - progress) / (1 - progressStart);

      currentParallax = currentPercent * height * parallax;

      ctx[0].rect(left, top, width, clipHeight);
      ctx[0].closePath();
      ctx[0].clip();
      ctx[0].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y + currentParallax, nextImageSize.imageWidth, nextImageSize.imageHeight);
      ctx[0].restore();

      // prev (1)

      ctx[1].save();
      ctx[1].beginPath();

      img = images[num !== null ? num : getPrev()];
      nextImageSize = imageSize({
        img
      });

      clipHeight = height * progress;
      top = 0;
      left = 0;
      currentParallax = 0;

      if (progress <= controls) {
        currentParallax = height * parallax * -1;
      } else {
        currentParallax = (1 - progress) / (1 - controls) * height * parallax * -1;
      }

      ctx[1].rect(left, top, width, clipHeight);
      ctx[1].closePath();
      ctx[1].clip();
      ctx[1].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y + currentParallax, nextImageSize.imageWidth, nextImageSize.imageHeight);
      ctx[1].restore();

      if (progress === 1) {

        // events
        after.call(this, active, num !== null ? num : getPrev());

        active = num !== null ? num : getPrev();
        eventAnimation = false;
        setStart(active);
        if (continueInterval === true) {
          setIntervalFunc();
        }
      }
    }

    // set events

    function setKeydown() {
      const bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (bool !== true & bool !== false) return false;
      keydown = bool;
    }

    function setSwipe() {
      const bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (bool !== true & bool !== false) return false;
      swipe = bool;
    }

    function setWheel() {
      const bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (bool !== true & bool !== false) return false;
      wheel = bool;
    }

    // interval

    function setIntervalFunc() {
      clearInterval(intervalFunc);
      intervalFunc = setInterval(next.bind(this, 'interval'), interval);
      intervalFuncEnabled = true;
    }

    function clearIntervalFunc() {
      clearInterval(intervalFunc);
      intervalFuncEnabled = false;
    }

    if (intervalBool === true) {
      setIntervalFunc();
    }

    init();

    // Resize

    v.resizeArray.push(['wh', function () {
      sizes();
      setStart(active);
      setTimeout(() => {
        sizes();
        setStart(active);
      }, 500);
    }]);

    // Keydown

    window.addEventListener("keydown", (e) => {
      if (keydown === true & (e.which == 37 || e.which == 38 || e.which == 39 || e.which == 40)) {
        // left
        if (e.which == 37) {
          prev('', 0);
        }
        // up
        if (e.which == 38) {
          prev('', 0);
        }
        // right
        if (e.which == 39) {
          next('', 0);
        }
        // down
        if (e.which == 40) {
          next('', 0);
        }
      }
    });

    // Swipe

    let touchXStart = 0,
      touchYStart = 0,
      swipeK = 75;

    // touchstart
    window.addEventListener("touchstart", (e) => {
      touchXStart = e.targetTouches[0].pageX;
      touchYStart = e.targetTouches[0].pageY;
    });

    // touchend
    window.addEventListener("touchend", (e) => {
      if (swipe === true) {
        let touchX = e.changedTouches[0].pageX,
          touchY = e.changedTouches[0].pageY;
        // x
        if (touchX < touchXStart) {
          if (touchXStart > touchX + swipeK) {
            next('', 0);
            return false;
          }
        } else if (touchX > touchXStart) {
          if (touchX > touchXStart + swipeK) {
            prev('', 0);
            return false;
          }
        }
        // y
        if (touchY < touchYStart) {
          if (touchYStart > touchY + swipeK) {
            next('', 0);
            return false;
          }
        } else if (touchY > touchYStart) {
          if (touchY > touchYStart + swipeK) {
            prev('', 0);
            return false;
          }
        }
      }
    });

    let timeStamp = new Date().getTime(),
      deltaY = 0.5;

    $(window).bind('wheel', (e) => {
      if (wheel === true) {
        let timeNow = new Date().getTime();
        if (timeNow - timeStamp < 100) {
          timeStamp = timeNow;
          return;
        }
        timeStamp = timeNow;

        e.preventDefault();
        // Up
        if (e.originalEvent.deltaY < 0 & e.originalEvent.deltaY < deltaY * -1) {
          prev();
        }
        // Down
        if (e.originalEvent.deltaY > 0 & e.originalEvent.deltaY > deltaY) {
          next();
        }
      }
    });

    // Next Button

    nextButton.onclick = next.bind(this);

    return {
      getNext,
      next,
      prev,
      set,
      setStart,
      setKeydown,
      setSwipe,
      setWheel,
      setIntervalFunc,
      clearIntervalFunc,
      nextHover,
      nextHoverHide
    };
  };
  v.canvasZoomSlider = function () {
    let _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        selector: "#v-canvas-zoom-slider",
        active: 0,
        bezier: [false, [0, 2, -1, 1]],
        animation: 500,
        parallax: .05,
        zoom: true,
        zoomAnimation: 250,
        zoomK: 2,
        keydown: true,
        swipe: true,
        wheel: true,
        intervalBool: false,
        interval: 5000,
        before: function before() {},
        after: function after() {},
        firstStartCallback: function firstStartCallback() {}
      },
      _ref26$selector = _ref26.selector,
      selector = _ref26$selector === undefined ? "#v-canvas-zoom-slider" : _ref26$selector,
      _ref26$active = _ref26.active,
      active = _ref26$active === undefined ? 0 : _ref26$active,
      _ref26$bezier = _ref26.bezier,
      bezier = _ref26$bezier === undefined ? [false, [0, 2, -1, 1]] : _ref26$bezier,
      _ref26$animation = _ref26.animation,
      animation = _ref26$animation === undefined ? 500 : _ref26$animation,
      _ref26$parallax = _ref26.parallax,
      parallax = _ref26$parallax === undefined ? .05 : _ref26$parallax,
      _ref26$zoom = _ref26.zoom,
      zoom = _ref26$zoom === undefined ? true : _ref26$zoom,
      _ref26$zoomAnimation = _ref26.zoomAnimation,
      zoomAnimation = _ref26$zoomAnimation === undefined ? 250 : _ref26$zoomAnimation,
      _ref26$zoomK = _ref26.zoomK,
      zoomK = _ref26$zoomK === undefined ? 2 : _ref26$zoomK,
      _ref26$keydown = _ref26.keydown,
      keydown = _ref26$keydown === undefined ? true : _ref26$keydown,
      _ref26$swipe = _ref26.swipe,
      swipe = _ref26$swipe === undefined ? true : _ref26$swipe,
      _ref26$wheel = _ref26.wheel,
      wheel = _ref26$wheel === undefined ? true : _ref26$wheel,
      _ref26$intervalBool = _ref26.intervalBool,
      intervalBool = _ref26$intervalBool === undefined ? false : _ref26$intervalBool,
      _ref26$interval = _ref26.interval,
      interval = _ref26$interval === undefined ? 5000 : _ref26$interval,
      _ref26$before = _ref26.before,
      before = _ref26$before === undefined ? function () {} : _ref26$before,
      _ref26$after = _ref26.after,
      after = _ref26$after === undefined ? function () {} : _ref26$after,
      _ref26$firstStartCall = _ref26.firstStartCallback,
      firstStartCallback = _ref26$firstStartCall === undefined ? function () {} : _ref26$firstStartCall;

    // define

    let outer = false,
      imagesOriginal = [],
      images = [],
      imagesLoaded = 0,
      count = 0,
      canvas = [],
      ctx = [],
      width = 0,
      height = 0,
      eventAnimation = false,
      intervalFunc = false,
      intervalFuncEnabled = intervalBool,
      play = null,
      zoomButton = false,
      mobileZoom = false,
      navButton = false,
      navCount = false,
      prevButton = false,
      nextButton = false,
      navUl = false,
      navUlLi = [],
      controlsButton = null,
      controlsItems = [],
      controlsOuter = null,
      controlsBool = false,
      zoomBool = false,
      zoomEvent = false,
      zoomProceeding = false,
      zoomX = 0,
      zoomY = 0,
      firstStart = true;

    // init

    function init() {

      // check

      outer = document.querySelector(selector);
      if (outer === null) {
        v.consoleError(`canvasSelector: There's no such an element "${  selector  }"`);
        return false;
      }
      outer.classList.add("v-canvas-zoom-slider");

      canvas = outer.querySelectorAll("canvas");
      if (canvas.length < 2) {
        v.consoleError(`canvasSelector: There's no 2 canvas in "${  outer  }"`);
        return false;
      }
      ctx[0] = canvas[0].getContext('2d');
      ctx[1] = canvas[1].getContext('2d');

      // nav button

      navButton = document.createElement("div");
      navButton.classList.add("nav-button");
      outer.appendChild(navButton);

      navCount = document.createElement("div");
      navCount.classList.add("nav-count");
      navButton.appendChild(navCount);

      prevButton = document.createElement("div");
      prevButton.classList.add("control");
      prevButton.classList.add("prev");
      navButton.appendChild(prevButton);

      nextButton = document.createElement("div");
      nextButton.classList.add("control");
      nextButton.classList.add("next");
      navButton.appendChild(nextButton);

      zoomButton = document.createElement("div");
      zoomButton.classList.add("zoom-button");
      zoomButton.classList.add("display-none");
      outer.appendChild(zoomButton);

      // mobile zoom

      mobileZoom = document.createElement("div");
      mobileZoom.classList.add("mobile-zoom");
      mobileZoom.classList.add("display-none");
      outer.appendChild(mobileZoom);

      sizes();

      const ul = outer.querySelector("ul");
      if (ul === null) {
        v.consoleError(`canvasSelector: There's no ul in "${  outer  }"`);
        return false;
      }

      const children = ul.querySelectorAll("li");
      if (children.length === 0) {
        v.consoleError(`canvasSelector: There's no li in "${  ul  }"`);
        return false;
      }

      for (let i = 0; i < children.length; i++) {
        let image = children[i].querySelector("img");
        if (image === null) {
          v.consoleError(`canvasSelector: There's no img in "${  children[i]  }"`);
          return false;
        }
        const src = image.getAttribute("src");
        if (src === null || src.length === 0) {
          v.consoleError(`canvasSelector: Wrong src in "${  image  }"`);
          return false;
        }
        imagesOriginal.push(image);
        image = new Image();
        image.addEventListener('load', () => {
          imagesLoaded++;
          setStart(active);
        }, false);
        image.src = src;
        images.push(image);
      }

      count = images.length;

      // nav

      navUl = document.createElement("ul");
      navUl.classList.add("nav");
      outer.appendChild(navUl);
      for (let _i29 = 0; _i29 < count; _i29++) {
        const li = document.createElement("li");
        navUl.appendChild(li);
        navUlLi.push(li);
        li.onclick = set.bind(this, _i29);
      }

      // controls button

      controlsButton = document.createElement("div");
      controlsButton.classList.add("controls-button");
      outer.appendChild(controlsButton);

      controlsOuter = document.createElement("div");
      controlsOuter.classList.add("controls-outer");
      outer.appendChild(controlsOuter);

      for (let _i30 = 0; _i30 < imagesOriginal.length; _i30++) {
        let videoClass = '';
        if (imagesOriginal[_i30].getAttribute("data-video") === 'true' & imagesOriginal[_i30].getAttribute("data-video-url") !== null) {
          videoClass = 'video';
        }
        const item = document.createElement("div");
        item.classList.add("item");
        item.innerHTML = `<div class="image ${  videoClass  }" style="background-image: url('${  imagesOriginal[_i30].getAttribute("src")  }')"></div>`;
        controlsOuter.appendChild(item);
        controlsItems.push(item);
        item.onclick = controlsSet.bind(this, _i30);
      }

      // play

      play = document.createElement("div");
      play.classList.add("play");
      outer.appendChild(play);
      play.onclick = playVideo.bind(this);
    }

    // sizes

    function sizes() {

      width = canvas[1].clientWidth;
      height = canvas[1].clientHeight;

      for (let i = 0; i < canvas.length; i++) {
        canvas[i].width = width;
        canvas[i].height = height;
      }
    }

    // animate

    function bezierFunc(c0, c1, c2, c3, t) {
      const coord = Math.pow(1 - t, 3) * c0 + 3 * Math.pow(1 - t, 2) * t * c1 + 3 * (1 - t) * Math.pow(t, 2) * c2 + Math.pow(t, 3) * c3;
      return coord;
    }

    function animate(duration, callback) {
      const percent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;


      const startedAt = Date.now();

      const func = function func() {

        let progress = (Date.now() - startedAt) / duration;
        let progressOutput = percent + (1 - percent) * progress;
        let progressBezier = progressOutput;
        if (bezier[0] === true) {
          progressBezier = progressOutput * bezierFunc(bezier[1][0], bezier[1][1], bezier[1][2], bezier[1][3], progressOutput);
        }

        if (progress >= 1) {
          progress = 1;
          progressOutput = 1;
          progressBezier = 1;
        }

        callback(duration, progressOutput, percent, progressBezier);

        if (progress < 1) {
          window.requestAnimationFrame(func);
        }
      };

      window.requestAnimationFrame(func);
    };

    // image size

    function imageSize(_ref27) {
      const img = _ref27.img;


      let imageWidth = width,
        imageHeight = img.height * imageWidth / img.width,
        x = 0,
        y = (height - imageHeight) / 2;

      if (imageHeight < height) {
        imageHeight = height;
        imageWidth = img.width * imageHeight / img.height;
        x = (width - imageWidth) / 2;
        y = 0;
      }

      return {
        img,
        imageWidth,
        imageHeight,
        x,
        y
      };
    }

    // set start

    function setStart(num) {

      if (imagesLoaded !== count) return false;
      if (firstStart === true) {
        firstStartCallback();
      }

      // active

      active = num;

      ctx[0].clearRect(0, 0, width, height);

      const activeImageSize = imageSize({
        img: images[num]
      });

      if (controlsBool === true) {
        if (v.viewportWidth[1] > 760) {
          ctx[0].filter = 'blur(15px)';
        }
      }
      ctx[0].drawImage(images[num], 0, 0, images[num].width, images[num].height, activeImageSize.x, activeImageSize.y, activeImageSize.imageWidth, activeImageSize.imageHeight);
      if (controlsBool === true) {
        if (v.viewportWidth[1] <= 760 || ctx[0].filter == undefined || v.browser === 'safari' || v.browser === 'edge') {
          /* ctx[0].fillStyle = 'rgba(238,238,238,.8)';
          ctx[0].fillRect(0,0,width, height); */
          outer.classList.add("controls-open");
        } else {
          outer.classList.remove("controls-open");
        }
      } else {
        outer.classList.remove("controls-open");
      }

      // next

      ctx[1].save();
      ctx[1].beginPath();
      ctx[1].clearRect(0, 0, width, height);

      // nav count

      let navCountCurrent = active + 1 < 10 ? `0${  active + 1}` : active + 1,
        navCountTotal = count < 10 ? `0${  count}` : count;
      navCount.innerHTML = `<span class="current">${  navCountCurrent  }</span>/${  navCountTotal}`;

      // video

      let currentImage = imagesOriginal[active],
        url = currentImage.getAttribute("data-video-url"),
        playFadeTime = firstStart === true ? 0 : animation / 2;
      if (currentImage.getAttribute("data-video") === 'true' & url !== null) {
        $(play).stop().fadeIn(playFadeTime);
      }

      firstStart = false;

      // update nav

      updateNav();
    }

    // set slide

    function set() {
      let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;


      num = parseInt(num);
      if (num < 0) return false;
      if (num > count - 1) return false;

      if (num === active) {
        return false;
      }

      if (num < active) {
        prev('', 0, num);
      }

      if (num > active) {
        next('', 0, num);
      }
    }

    // update nav

    function updateNav() {

      for (let i = 0; i < navUlLi.length; i++) {
        navUlLi[i].classList.remove("active");
      }

      navUlLi[active].classList.add("active");
    }

    // controls

    function controlsSet() {
      const num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      const e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      controlsOpenClose(set.bind(this, num));
    }

    function controlsOpenClose() {
      const callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


      if (zoomEvent === true) return;
      if (eventAnimation === true & controlsBool === false) return;
      eventAnimation = true;

      // open

      if (controlsBool !== true) {

        $(play).stop().fadeOut(animation / 2);

        animate(250, blur.bind(this, true), 0);

        controlsButton.classList.add("active");
        if (v.viewportWidth[1] <= 1024 || ctx[0].filter == undefined || v.browser === 'safari' || v.browser === 'edge') {
          outer.classList.add("controls-open");
        }

        controlsOuter.classList.add("active");
        for (let i = 0; i < controlsItems.length; i++) {
          controlsItems[i].classList.remove("active");
        }

        setTimeout(() => {
          for (let _i31 = 0; _i31 < controlsItems.length; _i31++) {
            setTimeout(((e, num) => {
              if (num === controlsItems.length - 1) controlsBool = true;
              e.classList.add("active");
            }).bind(this, controlsItems[_i31], _i31), _i31 * 100);
          }
        }, v.timeMin);
      }

      // close
      else {

        animate(250, blur.bind(this, false), 0);

        outer.classList.remove("controls-open");

        for (let _i32 = controlsItems.length - 1, a = 0; _i32 >= 0; _i32--, a++) {
          setTimeout(((e, num) => {
            if (num === 0) {
              setTimeout(() => {
                controlsBool = false;
                controlsButton.classList.remove("active");
                controlsOuter.classList.remove("active");
                eventAnimation = false;
                if (callback !== null & typeof callback === 'function') {
                  callback();
                } else {
                  let currentImage = imagesOriginal[active],
                    url = currentImage.getAttribute("data-video-url");
                  if (currentImage.getAttribute("data-video") === 'true' & url !== null) {
                    $(play).stop().fadeIn(animation / 2);
                  }
                }
              }, 250 + v.timeMin);
            }
            e.classList.remove("active");
          }).bind(this, controlsItems[_i32], _i32), a * 100);
        }
      }
    }

    function blur() {
      const bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      const duration = arguments[1];
      const progress = arguments[2];
      const progressStart = arguments[3];
      const progressBezier = arguments[4];


      // ative

      ctx[0].save();
      ctx[0].beginPath();

      let img = images[active],
        nextImageSize = imageSize({
          img
        });

      let clipHeight = height,
        top = 0,
        left = 0,
        currentParallax = 0,
        currentPercent = (1 - progressBezier) / (1 - progressStart);

      if (bool === true) currentPercent = 1 - currentPercent;
      const currentBlur = 15 * currentPercent;
      const currentOverlay = .8 * currentPercent;

      ctx[0].rect(left, top, width, clipHeight);
      ctx[0].closePath();
      ctx[0].clip();
      if (v.viewportWidth[1] > 760) {
        ctx[0].filter = `blur(${  currentBlur  }px)`;
      }
      ctx[0].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y, nextImageSize.imageWidth, nextImageSize.imageHeight);
      if (v.viewportWidth[1] <= 760 || ctx[0].filter == undefined) {
        /* ctx[0].fillStyle = 'rgba(238,238,238,' + currentOverlay + ')';
        ctx[0].fill(); */
      }

      ctx[0].restore();
    }

    // Zoom

    function zoomEnableDisable() {

      let further = true;
      if (eventAnimation === true || controlsBool === true) further = false;
      if (zoomProceeding === true) further = false;
      if (zoom !== true) further = false;
      if (imagesOriginal[active].getAttribute("data-video") !== null) further = false;
      // if(v.viewportWidth[1] < v.properties.tablet) further = false;

      if (further === true) {

        // enable

        if (zoomBool !== true) {

          outer.classList.add("zoom-canvas");
          document.documentElement.classList.add("zoom-canvas");

          // if(v.viewportWidth[1] > v.properties.tablet){
          zoomProceeding = true;
          zoomEvent = true;
          animate(zoomAnimation, zoomAnimate.bind(this, true), 0);
          /* }
          else{
              zoomEvent = true;
              zoomProceeding = false;
              zoomBool = true;
          } */

          mobileZoom.innerHTML = `<div class="bg-image" style="background-image: url('${  images[active].src  }');"></div>`;
          mobileZoom.classList.add("shown");
          mobileZoom.scrollTop = canvas[1].clientHeight / zoomK;
          mobileZoom.scrollLeft = canvas[1].clientWidth / zoomK;

          $(controlsButton).stop().fadeOut(zoomAnimation);
          $(navButton).stop().fadeOut(zoomAnimation);
          $(navUl).stop().fadeOut(zoomAnimation);
        } else {

          outer.classList.remove("zoom-canvas");
          document.documentElement.classList.remove("zoom-canvas");

          if (v.viewportWidth[1] <= v.properties.tablet) {
            zoomX = mobileZoom.scrollLeft;
            zoomY = mobileZoom.scrollTop;
          }
          mobileZoom.classList.remove("shown");
          mobileZoom.classList.remove("shown-opacity");

          if (v.viewportWidth[1] > v.properties.tablet) {
            zoomProceeding = true;
            animate(zoomAnimation, zoomAnimate.bind(this, false), 0);
          } else {
            zoomProceeding = true;
            animate(zoomAnimation, zoomAnimate.bind(this, false), 0);
          }

          $(controlsButton).stop().fadeIn(zoomAnimation);
          $(navButton).stop().fadeIn(zoomAnimation);
          $(navUl).stop().fadeIn(zoomAnimation);
        }
      }
    }

    function zoomAnimate() {
      const bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      const duration = arguments[1];
      const progress = arguments[2];
      const progressStart = arguments[3];
      const progressBezier = arguments[4];


      // ative

      ctx[0].save();
      ctx[0].beginPath();

      let img = images[active],
        nextImageSize = imageSize({
          img
        });

      let clipHeight = height,
        top = 0,
        left = 0,
        currentParallax = 0,
        currentPercent = (1 - progressBezier) / (1 - progressStart),
        scalePercent = currentPercent,
        currentZoomX = 0,
        currentZoomY = 0;

      if (bool === true) scalePercent = 1 - scalePercent;
      scalePercent = (zoomK - 1) * scalePercent + 1;

      currentZoomX = zoomX / width * width * (1 - zoomK);
      currentZoomY = zoomY / height * height * (1 - zoomK);
      if (bool === true) {
        currentZoomX *= 1 - currentPercent;
        currentZoomY *= 1 - currentPercent;
      } else {
        currentZoomX *= currentPercent;
        currentZoomY *= currentPercent;
      }

      ctx[0].clearRect(0, 0, width, height);
      ctx[0].rect(left, top, width, clipHeight);
      ctx[0].closePath();
      ctx[0].translate(currentZoomX, currentZoomY);
      ctx[0].scale(scalePercent, scalePercent);
      ctx[0].clip();
      ctx[0].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y, nextImageSize.imageWidth, nextImageSize.imageHeight);

      ctx[0].restore();

      if (progressBezier === 1) {
        if (bool === true) {
          zoomBool = true;
          requestAnimationFrame(zoomMove);
          mobileZoom.classList.add("shown-opacity");
        } else {
          zoomBool = false;
          zoomEvent = false;
        }
        zoomProceeding = false;
      }
    }

    function zoomMove() {

      if (zoomProceeding === true) return;

      // ative

      ctx[0].save();
      ctx[0].beginPath();

      let img = images[active],
        nextImageSize = imageSize({
          img
        });

      let clipHeight = height,
        top = 0,
        left = 0,
        scalePercent = 1,
        currentZoomX = 0,
        currentZoomY = 0;

      scalePercent = (zoomK - 1) * scalePercent + 1;

      currentZoomX = zoomX / width * width * (1 - zoomK);
      currentZoomY = zoomY / height * height * (1 - zoomK);

      ctx[0].clearRect(0, 0, width, height);
      ctx[0].rect(left, top, width, clipHeight);
      ctx[0].closePath();
      ctx[0].translate(currentZoomX, currentZoomY);
      ctx[0].scale(scalePercent, scalePercent);
      ctx[0].clip();
      ctx[0].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y, nextImageSize.imageWidth, nextImageSize.imageHeight);

      ctx[0].restore();

      requestAnimationFrame(zoomMove);
    }

    // play video

    function playVideo() {

      let currentImage = imagesOriginal[active],
        url = currentImage.getAttribute("data-video-url");
      if (currentImage.getAttribute("data-video") === 'true' & url !== null) {

        const html = `<iframe src="${  url  }" frameborder="0" allowfullscreen></iframe>`;
        v.popup.openFirst('html', html, 'video');
      }
    }

    // get next

    function getNext() {
      const num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : active;


      let newActive = num;
      newActive += 1;
      if (newActive > count - 1) {
        newActive = 0;
      }
      return newActive;
    }

    // get prev

    function getPrev() {
      const num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : active;


      let newActive = num;
      newActive -= 1;
      if (newActive < 0) {
        newActive = count - 1;
      }
      return newActive;
    }

    // next

    function next() {
      const type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      const percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      const num = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


      if (eventAnimation === true || zoomEvent === true) return;

      let continueInterval = false;
      if (type !== 'interval' & intervalFuncEnabled === true) {
        clearIntervalFunc();
        continueInterval = true;
      }

      eventAnimation = true;

      // events
      before.call(this, active, num !== null ? num : getNext());

      animate(animation, nextAnimate.bind(this, continueInterval, type, num), percent);

      $(play).stop().fadeOut(animation / 2);
    }

    // next animate

    function nextAnimate(continueInterval, type, num, duration, progress, progressStart, progressBezier) {

      // ative

      ctx[0].save();
      ctx[0].beginPath();

      let img = images[active],
        nextImageSize = imageSize({
          img
        });

      if (v.viewportWidth[1] >= 1025) {

        let clipHeight = height,
          top = 0,
          left = 0,
          currentParallax = 0,
          currentPercent = 1 - (1 - progressBezier) / (1 - progressStart);

        currentParallax = currentPercent * height * parallax * -1;

        ctx[0].rect(left, top, width, clipHeight);
        ctx[0].closePath();
        ctx[0].clip();
        ctx[0].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y + currentParallax, nextImageSize.imageWidth, nextImageSize.imageHeight);
        ctx[0].restore();

        // next (1)

        ctx[1].save();
        ctx[1].beginPath();

        img = images[num !== null ? num : getNext()];
        nextImageSize = imageSize({
          img
        });

        clipHeight = height * progressBezier;
        top = 0;
        left = 0;
        currentParallax = 0;

        currentParallax = (1 - progressBezier) * height * parallax;

        ctx[1].rect(left, top, width, clipHeight);
        ctx[1].closePath();
        ctx[1].clip();
        ctx[1].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y + currentParallax, nextImageSize.imageWidth, nextImageSize.imageHeight);
        ctx[1].restore();
      } else {

        let clipWidth = width,
          _top = 0,
          _left = 0,
          _currentParallax = 0,
          _currentPercent = 1 - (1 - progressBezier) / (1 - progressStart);

        _currentParallax = _currentPercent * width * parallax * -1;

        ctx[0].rect(_left, _top, clipWidth, height);
        ctx[0].closePath();
        ctx[0].clip();
        ctx[0].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x + _currentParallax, nextImageSize.y, nextImageSize.imageWidth, nextImageSize.imageHeight);
        ctx[0].restore();

        // next (1)

        ctx[1].save();
        ctx[1].beginPath();

        img = images[num !== null ? num : getNext()];
        nextImageSize = imageSize({
          img
        });

        clipWidth = width * progressBezier;
        _top = 0;
        _left = width - clipWidth;
        _currentParallax = 0;

        _currentParallax = (1 - progressBezier) * width * parallax;

        ctx[1].rect(_left, _top, clipWidth, height);
        ctx[1].closePath();
        ctx[1].clip();
        ctx[1].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x + _currentParallax, nextImageSize.y, nextImageSize.imageWidth, nextImageSize.imageHeight);
        ctx[1].restore();
      }

      if (progressBezier === 1) {

        // events
        after.call(this, active, num !== null ? num : getNext());

        active = num !== null ? num : getNext();
        eventAnimation = false;
        setStart(active);
        if (continueInterval === true) {
          setIntervalFunc();
        }
      }
    }

    // prev

    function prev() {
      const type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      const percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      const num = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


      if (eventAnimation === true || zoomEvent === true) return;

      let continueInterval = false;
      if (type !== 'interval' & intervalFuncEnabled === true) {
        clearIntervalFunc();
        continueInterval = true;
      }

      eventAnimation = true;

      // events
      before.call(this, active, num !== null ? num : getPrev());

      animate(animation, prevAnimate.bind(this, continueInterval, type, num), percent);

      $(play).stop().fadeOut(animation / 2);
    }

    // prev animate

    function prevAnimate(continueInterval, type, num, duration, progress, progressStart, progressBezier) {

      // ative

      ctx[0].save();
      ctx[0].beginPath();

      let img = images[active],
        nextImageSize = imageSize({
          img
        });

      if (v.viewportWidth[1] >= 1025) {

        let clipHeight = height,
          top = 0,
          left = 0,
          currentParallax = 0,
          currentPercent = 1 - (1 - progressBezier) / (1 - progressStart);

        currentParallax = currentPercent * height * parallax;

        ctx[0].rect(left, top, width, clipHeight);
        ctx[0].closePath();
        ctx[0].clip();
        ctx[0].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y + currentParallax, nextImageSize.imageWidth, nextImageSize.imageHeight);
        ctx[0].restore();

        // prev (1)

        ctx[1].save();
        ctx[1].beginPath();

        img = images[num !== null ? num : getPrev()];
        nextImageSize = imageSize({
          img
        });

        clipHeight = height * progressBezier;
        top = height - clipHeight;
        left = 0;
        currentParallax = 0;

        currentParallax = (1 - progressBezier) * height * parallax * -1;

        ctx[1].rect(left, top, width, clipHeight);
        ctx[1].closePath();
        ctx[1].clip();
        ctx[1].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x, nextImageSize.y + currentParallax, nextImageSize.imageWidth, nextImageSize.imageHeight);
        ctx[1].restore();
      } else {

        let clipWidth = width,
          _top2 = 0,
          _left2 = 0,
          _currentParallax2 = 0,
          _currentPercent2 = 1 - (1 - progressBezier) / (1 - progressStart);

        _currentParallax2 = _currentPercent2 * width * parallax;

        ctx[0].rect(_left2, _top2, clipWidth, height);
        ctx[0].closePath();
        ctx[0].clip();
        ctx[0].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x + _currentParallax2, nextImageSize.y, nextImageSize.imageWidth, nextImageSize.imageHeight);
        ctx[0].restore();

        // prev (1)

        ctx[1].save();
        ctx[1].beginPath();

        img = images[num !== null ? num : getPrev()];
        nextImageSize = imageSize({
          img
        });

        clipWidth = width * progressBezier;
        _left2 = 0;
        _top2 = 0;
        _currentParallax2 = 0;

        _currentParallax2 = (1 - progressBezier) * width * parallax * -1;

        ctx[1].rect(_left2, _top2, clipWidth, height);
        ctx[1].closePath();
        ctx[1].clip();
        ctx[1].drawImage(img, 0, 0, img.width, img.height, nextImageSize.x + _currentParallax2, nextImageSize.y, nextImageSize.imageWidth, nextImageSize.imageHeight);
        ctx[1].restore();
      }

      if (progressBezier === 1) {

        // events
        after.call(this, active, num !== null ? num : getPrev());

        active = num !== null ? num : getPrev();
        eventAnimation = false;
        setStart(active);
        if (continueInterval === true) {
          setIntervalFunc();
        }
      }
    }

    // set events

    function setKeydown() {
      const bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (bool !== true & bool !== false) return false;
      keydown = bool;
    }

    function setSwipe() {
      const bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (bool !== true & bool !== false) return false;
      swipe = bool;
    }

    function setWheel() {
      const bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (bool !== true & bool !== false) return false;
      wheel = bool;
    }

    // interval

    function setIntervalFunc() {
      clearInterval(intervalFunc);
      intervalFunc = setInterval(next.bind(this, 'interval'), interval);
      intervalFuncEnabled = true;
    }

    function clearIntervalFunc() {
      clearInterval(intervalFunc);
      intervalFuncEnabled = false;
    }

    if (intervalBool === true) {
      setIntervalFunc();
    }

    init();

    // Resize

    v.resizeArray.push(['wh', function () {
      sizes();
      setStart(active);
      setTimeout(() => {
        sizes();
        setStart(active);
      }, 500);
    }]);

    // Keydown

    window.addEventListener("keydown", (e) => {
      if (keydown === true & (e.which == 37 || e.which == 38 || e.which == 39 || e.which == 40)) {
        // left
        if (e.which == 37) {
          prev('', 0);
        }
        // up
        if (e.which == 38) {
          prev('', 0);
        }
        // right
        if (e.which == 39) {
          next('', 0);
        }
        // down
        if (e.which == 40) {
          next('', 0);
        }
      }
    });

    // Swipe

    let touchXStart = 0,
      touchYStart = 0,
      swipeK = 75;

    // touchstart
    outer.addEventListener("touchstart", (e) => {
      touchXStart = e.targetTouches[0].pageX;
      touchYStart = e.targetTouches[0].pageY;
    });

    // touchend
    outer.addEventListener("touchend", (e) => {
      if (swipe === true) {
        var touchX = e.changedTouches[0].pageX,
          touchY = e.changedTouches[0].pageY;
        if (v.viewportWidth[1] >= 1025) {
          // y
          if (touchY < touchYStart) {
            if (touchYStart > touchY + swipeK) {
              next('', 0);
              return;
            }
          } else if (touchY > touchYStart) {
            if (touchY > touchYStart + swipeK) {
              prev('', 0);
              return;
            }
          }
        } else {
          // x
          if (touchX < touchXStart) {
            if (touchXStart > touchX + swipeK) {
              next('', 0);

            }
          } else if (touchX > touchXStart) {
            if (touchX > touchXStart + swipeK) {
              prev('', 0);

            }
          }
        }
      }
    });

    let timeStamp = new Date().getTime(),
      deltaY = 0.5;

    $(outer).bind('wheel', (e) => {
      if (wheel === true) {
        let timeNow = new Date().getTime();
        if (timeNow - timeStamp < 100) {
          timeStamp = timeNow;
          return;
        }
        timeStamp = timeNow;

        e.preventDefault();
        // Up
        if (e.originalEvent.deltaY < 0 & e.originalEvent.deltaY < deltaY * -1) {
          prev();
        }
        // Down
        if (e.originalEvent.deltaY > 0 & e.originalEvent.deltaY > deltaY) {
          next();
        }
      }
    });

    // Nav Button

    prevButton.onclick = prev.bind(this);
    nextButton.onclick = next.bind(this);

    // Controls Button & Zoom

    controlsButton.onclick = controlsOpenClose.bind(this);

    let lastTap = new Date().getTime(),
      lastMoveX = 0,
      lastMoveY = 0;

    zoomButton.onclick = function () {
      zoomX = canvas[1].clientWidth / 2;
      zoomY = canvas[1].clientHeight / 2;
      lastMoveX = canvas[1].clientWidth / 2;
      lastMoveY = canvas[1].clientHeight / 2;
      zoomEnableDisable();
    };

    canvas[1].addEventListener("click", (e) => {
      if (v.viewportWidth[1] <= v.properties.tablet) {
        let now = new Date().getTime(),
          timesince = now - lastTap;
        if (timesince < 600 && timesince > 0) {
          if (zoomEvent === false) {
            /* zoomX = e.offsetX;
            zoomY = e.offsetY;
            lastMoveX = e.offsetX;
            lastMoveY = e.offsetY; */
            zoomX = canvas[1].clientWidth / 2;
            zoomY = canvas[1].clientHeight / 2;
            lastMoveX = canvas[1].clientWidth / 2;
            lastMoveY = canvas[1].clientHeight / 2;
          }
          zoomEnableDisable();
          if (controlsBool === true) {
            controlsOpenClose(false);
          }
        }
        lastTap = new Date().getTime();
      } else {
        zoomX = e.offsetX;
        zoomY = e.offsetY;
        lastMoveX = e.offsetX;
        lastMoveY = e.offsetY;
        zoomEnableDisable();
        if (controlsBool === true) {
          controlsOpenClose(false);
        }
      }
    });

    mobileZoom.addEventListener("click", (e) => {
      if (v.viewportWidth[1] <= v.properties.tablet) {
        let now = new Date().getTime(),
          timesince = now - lastTap;
        if (timesince < 600 && timesince > 0) {
          if (zoomEvent === false) {
            zoomX = canvas[1].clientWidth / 2;
            zoomY = canvas[1].clientHeight / 2;
            lastMoveX = canvas[1].clientWidth / 2;
            lastMoveY = canvas[1].clientHeight / 2;
          }
          zoomEnableDisable();
          if (controlsBool === true) {
            controlsOpenClose(false);
          }
        }
        lastTap = new Date().getTime();
      }
    });

    canvas[1].addEventListener("mousemove", (e) => {
      if (v.viewportWidth[1] > v.properties.tablet) {
        zoomX = e.offsetX;
        zoomY = e.offsetY;
      }
    });

    const lastSwipe = new Date().getTime();

    canvas[1].addEventListener("touchmove", (e) => {
      return;
      let now = new Date().getTime(),
        timesince = now - lastTap;
      if (e.changedTouches.length > 0 & (timesince < 25 && timesince > 0)) {

        let element = e.changedTouches[0].target,
          k = 75,
          kX = element.clientWidth / k,
          kY = element.clientHeight / k,
          newX = e.changedTouches[0].clientX,
          newY = e.changedTouches[0].clientY,
          diffX = lastMoveX - newX,
          diffY = lastMoveY - newY;

        if (diffX < 0) {
          diffX *= -1;
        }
        if (diffY < 0) {
          diffY *= -1;
        }
        diffX = kX;
        diffY = kY;

        let newZoomX = 0;
        let newZoomY = 0;
        if (newX > lastMoveX) {
          newZoomX = zoomX - diffX;
        } else {
          newZoomX = zoomX + diffX;
        }
        if (newY > lastMoveY) {
          newZoomY = zoomY - diffY;
        } else {
          newZoomY = zoomY + diffY;
        }
        console.log(newZoomY);

        if (newZoomX < 0) {
          newZoomX = 0;
        }
        if (newZoomX > element.clientWidth) {
          newZoomX = element.clientWidth;
        }
        if (newZoomY < 0) {
          newZoomY = 0;
        }
        if (newZoomY > element.clientHeight) {
          newZoomY = element.clientHeight;
        }
        zoomX = newZoomX;
        zoomY = newZoomY;

        lastMoveX = newX;
        lastMoveY = newY;
      }
      lastTap = new Date().getTime();
    });

    return {
      getNext,
      next,
      prev,
      set,
      setStart,
      setKeydown,
      setSwipe,
      setWheel,
      setIntervalFunc,
      clearIntervalFunc
    };
  };;
  (function () {

    Number.prototype.formatMoney = function (c, d, t) {
      var n = this,
        c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
      return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${  t}`) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    };

    // Preloader

    v.properties.consoleInfo = false;
    v.properties.consoleError = false;
    v.ajaxMaxTime = 2000;

    const preloader = v.preloader({
      linksPreloader: true,
      animationHome: 250,
      animationInnerHome: 0,
      animation: 350,
      animationInner: 0
    });

    v.loadArray.push(() => {
      setTimeout(() => {
        document.documentElement.classList.remove("none-transition");
      }, 300);
    });

    // Styles

    let additionalStyle = document.createElement("style"),
      additionalStyleArray = [];
    document.body.appendChild(additionalStyle);

    function initAdditionalStyle() {
      let string = '';
      for (let i = 0; i < additionalStyleArray.length; i++) {
        string += `${additionalStyleArray[i][0]  }{${  eval(additionalStyleArray[i][1])  }}`;
      }
      additionalStyle.innerHTML = string;
    }
    v.loadArray.push(initAdditionalStyle.bind(this));
    v.resizeArray.push(['wh', initAdditionalStyle.bind(this)]);

    // Common

    if (!v.checkPage("home123")) {
      window.wrap = document.getElementById("wrap");
      v.scroll({
        selector: "#wrap"
      });
      window.addEventListener("load", () => {
        v.scroll({
          selector: "#wrap"
        });
      });
      setTimeout(() => {
        v.scroll({
          selector: "#wrap"
        });
      }, 250);
      setTimeout(() => {
        v.scroll({
          selector: "#wrap"
        });
      }, 500);
      setTimeout(() => {
        v.scroll({
          selector: "#wrap"
        });
      }, 750);
    }

    if (!v.checkPage("catalog")) {
      window.lazy = v.lazy({
        percentPosition: 350
      });
    }

    // ajax scroll

    window.ajaxScroll = function (outer) {
      const wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.wrap;
      const evalString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'window.ajaxItems.loadMore();';


      if (outer === null) return;
      wrap.addEventListener("scroll", () => {
        if (outer !== null) {
          if (outer.getAttribute("data-ajaxScroll") !== null) return false;
          let bounding = outer.getBoundingClientRect(),
            edge = v.viewportHeight[1] - v.viewportHeight[1] * -2;
          if (v.browser === "safari" || v.os === "macos") {
            edge = v.viewportHeight[1];
          }
          if (bounding.bottom < edge) {
            outer.setAttribute("data-ajaxScroll", true);
            eval(evalString);
          }
        }
      });

      function check() {
        if (outer !== null) {
          if (outer.getAttribute("data-ajaxScroll") !== null) return false;
          let bounding = outer.getBoundingClientRect(),
            edge = v.viewportHeight[1] - v.viewportHeight[1] * -2;
          if (v.browser === "safari" || v.os === "macos") {
            edge = v.viewportHeight[1];
          }
          if (bounding.bottom < edge) {
            outer.setAttribute("data-ajaxScroll", true);
            eval(evalString);
          }
        }
      }

      return {
        check
      };
    };
    window.ajaxScrollBoolFunc = function (outer) {
      if (outer !== null) {
        setTimeout(() => {
          outer.removeAttribute("data-ajaxScroll");
        }, 250);
      }
    };

    // show items

    window.showItems = function (selector) {
      const timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

      const items = document.querySelectorAll(selector);
      for (let i = 0; i < items.length; i++) {
        setTimeout(((e) => {
          e.classList.add("show");
          e.setAttribute("data-show", true);
        }).bind(this, items[i]), (i + 1) * timeout);
      }
    };

    // Menu

    const menuOuter = document.querySelector("#menu-outer");

    const menu = v.menu({
      menuLinkBool: v.properties.menuLink !== undefined,
      menuLink: v.properties.menuLinkHref !== undefined ? v.properties.menuLinkHref : '',
      animation: function () {
        if (v.viewportWidth[1] >= 950) {
          return 25;
        }
        return 500;

      }(),
      animationInnerBool: function () {
        if (v.viewportWidth[1] >= 950) {
          return true;
        }
        return true;

      }(),
      animationInner: function () {
        if (v.viewportWidth[1] >= 950) {
          return 500;
        }
        return 0;

      }(),
      onShow() {
        if (v.checkPage("home")) {
          window.setSlider(false);
        }
        if (searchOpenedBool === true) {
          searchClose();
        }
      },
      onHide() {
        if (v.checkPage("home")) {
          window.setSlider(true);
        }
        setMenuSublinks();
      }
    });

    v.resizeArray.push(['wh', function () {
      if (v.viewportWidth[1] >= 950) {
        menu.changeProperties({
          animation: 25,
          animationInnerBool: true,
          animationInner: 500
        });
      } else {
        menu.changeProperties({
          animation: 500,
          animationInnerBool: true,
          animationInner: 0
        });
      }
    }]);

    const menuWrap = document.getElementById("wrap");
    v.scroll({
      selector: "#menu-wrap-outer",
      addClassDocument: "v-scroll-menu-wrap"
    });

    // scroll wrap - menu sublinks

    const menuSublinksOuter = document.querySelectorAll(".menu-sublinks");
    for (let i = 0; i < menuSublinksOuter.length; i++) {
      const attributeId = menuSublinksOuter[i].getAttribute("data-id");
      if (attributeId !== null) {
        v.scroll({
          selector: `.menu-sublinks[data-id='${  attributeId  }'] .menu-wrap-outer-sublinks`,
          addClassDocument: `v-scroll-menu-wrap-sublinks-${  attributeId}`
        });
      }
    }

    // mobile backs

    const menuMobileBacks = document.querySelectorAll(".menu-mobile-back");
    for (let _i33 = 0; _i33 < menuMobileBacks.length; _i33++) {
      menuMobileBacks[_i33].addEventListener("click", () => {
        setMenuSublinks();
      });
    }

    // menu vars

    let menuContent = document.querySelector("#menu-wrap-outer > .content"),
      menuLinksOuter = document.querySelector("#menu-wrap-outer .menu-links"),
      menuLinks = document.querySelectorAll("#menu-wrap-outer .menu-links li a"),
      menuImages = document.querySelector(".menu-outer .menu-images"),
      menuImagesArray = [],
      loginBool = false,
      menuSublinksArray = document.querySelectorAll(".menu-sublinks");

    // menu images

    menuImages.onclick = function () {
      if (loginBool === true) {
        loginOpenClose();
      } else {
        menu.showHide();

      }
    };


    function setMenuImage() {
      const num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      for (let _i34 = 0; _i34 < menuImagesArray.length; _i34++) {
        menuImagesArray[_i34].classList.remove("active");
      }
      if (num !== null) {
        menuImagesArray[num].classList.add("active");
      }
    }

    /* menuLinksOuter.addEventListener("mouseleave", function(){
        if(v.viewportWidth[1] > v.properties.tablet){
            menuLinksOuter.classList.remove("hover");
        }
    }.bind(this)); */

    // menu sublinks

    function setMenuSublinks() {
      const id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (id === null) {
        for (let _i35 = 0; _i35 < menuSublinksArray.length; _i35++) {
          if (v.viewportWidth[1] > 949) {
            if (!$(menuSublinksArray[_i35]).is(":hover")) {
              $(menuSublinksArray[_i35]).stop().fadeOut(500);
              const currentId = menuSublinksArray[_i35].getAttribute("data-id");
              if (currentId !== null) {
                const link = document.querySelector(`.menu-outer .right ul.menu-links li a[data-id='${  currentId  }']`);
                if (link !== null) {
                  link.classList.remove("hovered");
                  menuLinksOuter.classList.remove("hover");
                }
              }
            } else {
              const _currentId = menuSublinksArray[_i35].getAttribute("data-id");
              if (_currentId !== null) {
                const _link = document.querySelector(`.menu-outer .right ul.menu-links li a[data-id='${  _currentId  }']`);
                if (_link !== null) {
                  _link.classList.add("hovered");
                  menuLinksOuter.classList.add("hover");
                }
                let linkParent = _link.parentNode.parentNode,
                  linksInParent = linkParent.querySelectorAll("a"),
                  linkNum = 0;
                for (let a = 0; a < linksInParent.length; a++) {
                  const currentIdAttribute = linksInParent[a].getAttribute("data-id");
                  if (parseInt(currentIdAttribute) == parseInt(_currentId)) {
                    linkNum = a;
                  }
                }
                setMenuImage(linkNum);
              }
            }
          }
        }
        if (v.viewportWidth[1] <= 949) {
          $(".menu-links-sub-outer").stop().slideUp(400, () => {
            $("#menu-links-outer").stop().slideDown(400);
          });
        }
      } else {
        const _loop = function _loop(_i36) {
          const currentId = menuSublinksArray[_i36].getAttribute("data-id");
          if (currentId !== null) {
            if (parseInt(currentId) == id) {
              setMenuSublinks();
              if (v.viewportWidth[1] > 949) {
                $(menuSublinksArray[_i36]).stop().fadeIn(500);
                const _link2 = document.querySelector(`.menu-outer .right ul.menu-links li a[data-id='${  currentId  }']`);
                if (_link2 !== null) {
                  _link2.classList.add("hovered");
                }
                menuLinksOuter.classList.add("hover");
              } else {
                $("#menu-links-outer").stop().slideUp(400, () => {
                  $(`.menu-links-sub-outer[data-id='${  currentId  }']`).stop().slideDown(400);
                });
              }
            }
          }
        };

        for (let _i36 = 0; _i36 < menuSublinksArray.length; _i36++) {
          _loop(_i36);
        }
      }
    }

    // render mouseleave of sublinks

    for (let _i37 = 0; _i37 < menuSublinksArray.length; _i37++) {

      menuSublinksArray[_i37].addEventListener("mouseleave", ((link, num) => {
        if (v.viewportWidth[1] > v.properties.tablet) {
          setMenuSublinks();
        }
      }).bind(this, menuLinks[_i37], _i37));
    }

    // set hover of sublinks

    function menuMouseLeaveSublinks(outer) {

      let currentLinks = outer.querySelectorAll("a"),
        hovered = false;

      for (let _i38 = 0; _i38 < currentLinks.length; _i38++) {
        if ($(currentLinks[_i38]).is(":hover")) {
          hovered = true;
        }
      }

      if (hovered === false) {
        outer.classList.remove("hover");
      } else {
        outer.classList.add("hover");
      }
    }

    for (let _i39 = 0; _i39 < menuSublinksArray.length; _i39++) {

      const currentSublinks = menuSublinksArray[_i39].querySelectorAll("a");

      for (let a = 0; a < currentSublinks.length; a++) {

        currentSublinks[a].addEventListener("mouseleave", function (link, num) {
          if (v.viewportWidth[1] > v.properties.tablet) {
            setTimeout(menuMouseLeaveSublinks.bind(this, menuSublinksArray[num]), 50);
          }
        }.bind(this, currentSublinks[a], _i39));

        currentSublinks[a].addEventListener("mouseover", ((link, num) => {
          if (v.viewportWidth[1] > v.properties.tablet) {
            menuSublinksArray[num].classList.add("hover");
          }
        }).bind(this, currentSublinks[a], _i39));
      }
    }

    // render links

    function menuMouseLeave() {
      let hovered = false;
      for (let _i40 = 0; _i40 < menuLinks.length; _i40++) {
        if ($(menuLinks[_i40]).is(":hover")) {
          hovered = true;
        }
      }
      for (let _i41 = 0; _i41 < menuSublinksArray.length; _i41++) {
        if ($(menuSublinksArray[_i41]).is(":hover")) {
          hovered = true;
        }
      }
      if (hovered === false) {
        menuLinksOuter.classList.remove("hover");
      } else {
        menuLinksOuter.classList.add("hover");
      }
    }

    for (let _i42 = 0; _i42 < menuLinks.length; _i42++) {

      let image = menuLinks[_i42].getAttribute("data-image"),
        item = document.createElement("div");
      item.classList.add("item");
      item.classList.add("bg-image");
      item.style.backgroundImage = `url('${  image  }')`;
      menuImagesArray.push(item);


      menuLinks[_i42].addEventListener("mouseleave", function (link, num) {
        if (v.viewportWidth[1] > v.properties.tablet) {
          setMenuImage();
          setMenuSublinks();
          setTimeout(menuMouseLeave.bind(this), 50);
        }
      }.bind(this, menuLinks[_i42], _i42));

      menuLinks[_i42].addEventListener("mouseover", ((link, num) => {
        if (v.viewportWidth[1] > v.properties.tablet) {
          menuLinksOuter.classList.add("hover");
          setMenuImage(num);
          const _attributeId = link.getAttribute("data-id");
          if (_attributeId !== null) {
            setMenuSublinks(parseInt(_attributeId));
          }
        }
      }).bind(this, menuLinks[_i42], _i42));


    }
    // Header

    let prevScroll = 0;

    wrap.addEventListener("scroll", () => {
      if (v.viewportWidth[1] <= 949) {
        if (prevScroll > wrap.scrollTop) {
          document.documentElement.classList.remove('v-page-fixedheader');
        } else if (wrap.scrollTop > 100) {
          document.documentElement.classList.add('v-page-fixedheader');
        } else {
          document.documentElement.classList.remove('v-page-fixedheader');
        }
        prevScroll = wrap.scrollTop;
      }
    });




    // Search Button

    var searchButtonOuter = document.querySelector(".header-button.search-button"),
      searchForm = document.querySelector("#search-content form"),
      searchButton = document.querySelector("#search-button"),
      searchButtonTablet = document.querySelector("#search-button-tablet"),
      searchButtonClose = document.querySelector("#search-button-close"),
      searchButtonCloseTablet = document.querySelector("#search-close-button-tablet"),
      searchContent = document.querySelector("#search-content"),
      searchHtml = searchContent.querySelector("#search-html"),
      searchSubmit = searchContent.querySelector("#search-submit"),
      searchInputOuter = searchContent.querySelector("#search-input-outer"),
      searchVInput = searchContent.querySelector(".v-input"),
      searchInput = searchVInput.querySelector("#search-input"),
      searchButtonSubmit = searchVInput.querySelector("#search-button-submit"),
      searchOpenedBool = false,
      searchProceededBool = false,
      searchFirstAfterOpen = true;

    function searchOpen() {

      if (searchProceededBool === true) return false;
      searchProceededBool = true;
      document.documentElement.classList.add("search-opened");
      document.documentElement.classList.remove("search-closed");
      setTimeout(() => {
        searchButtonOuter.classList.add("display-none");
      }, 1000);
      searchOpenedBool = true;
      if (!v.checkPage("search")) v.menuDelayShow = 800;
      if (!v.checkPage("search")) {
        $(searchContent).delay(800).stop().fadeIn(500);
      } else {
        searchContent.classList.remove("display-none");
      }
      setTimeout(() => {
        searchProceededBool = false;
      }, 1300);

      if (v.checkPage("home")) {
        window.setSlider(false);
      }
    }

    function searchClose() {

      if (v.checkPage("search")) return false;
      if (searchProceededBool === true) return false;
      searchProceededBool = true;
      searchOpenedBool = false;
      searchButtonOuter.classList.remove("display-none");
      setTimeout(() => {
        document.documentElement.classList.remove("search-opened");
        document.documentElement.classList.add("search-closed");
      }, 300);
      setTimeout(() => {
        v.menuDelayShow = 0;
      }, 1000);
      $(searchContent).stop().fadeOut(300);
      setTimeout(() => {
        searchVInput.classList.remove("not-empty");
        searchVInput.classList.remove("progress");
        searchInputOuter.classList.remove("resize");
        searchVInput.classList.remove("show-label");
        searchVInput.classList.remove("show-label-opacity");
        // searchHtml.classList.add("display-none");
        $(searchHtml).stop().fadeOut(0);
        searchInput.value = '';
        searchProceededBool = false;
      }, 1250);
      searchFirstAfterOpen = true;

      if (v.checkPage("home")) {
        window.setSlider(true);
      }
    }

    searchButton.onclick = function (e) {
      e.preventDefault();
      if (searchOpenedBool === false) {
        if (menu.opened() === true) {
          menu.showHide();
          setTimeout(searchOpen.bind(this), 800);
        } else {
          searchOpen();
        }
      }
    }.bind(this);

    searchButtonTablet.onclick = function (e) {
      e.preventDefault();
      if (searchOpenedBool === false) {
        if (menu.opened() === true) {
          menu.showHide();
          setTimeout(searchOpen.bind(this), 800);
        } else {
          searchOpen();
        }
      }
    }.bind(this);

    searchButtonClose.onclick = function (e) {
      e.preventDefault();
      if (searchOpenedBool === true) {
        searchClose();
      }
    };

    searchButtonCloseTablet.onclick = function (e) {
      e.preventDefault();
      if (searchOpenedBool === true) {
        searchClose();
      }
    };

    v.scroll({
      selector: "#search-content-scroll",
      addClassDocument: "v-scroll-search-content"
    });

    searchInput.addEventListener("keyup", () => {
      if (searchInput.value.length >= 3) {
        searchVInput.classList.add("not-empty");
      } else {
        searchVInput.classList.remove("not-empty");
      }
    });

    searchButtonSubmit.addEventListener("click", () => {
      $(searchSubmit).click();
    });

    window.search = function () {

      if (searchInput.value.length < 3) return false;

      const timeCounter = +new Date();

      if (v.viewportWidth[1] >= 950) {

        searchVInput.classList.add("progress");
        setTimeout(() => {
          searchInputOuter.classList.add("resize");
        }, 1250);
        setTimeout(() => {
          searchVInput.classList.add("show-label");
        }, 1700);
        setTimeout(() => {
          searchVInput.classList.add("show-label-opacity");
          // searchHtml.classList.remove("display-none");
          $(searchHtml).stop().fadeIn(500);
        }, 1750);
      } else {
        searchVInput.classList.add("progress");
        searchInputOuter.classList.add("resize");
        searchVInput.classList.add("show-label");
        searchVInput.classList.add("show-label-opacity");
        $(searchHtml).stop().fadeIn(500);
      }

      let searchOrder = 'pb';
      if (v.checkPage("blog") || v.checkPage("text")) {
        searchOrder = 'bp';
      }

      if (v.checkPage("search")) {
        v.setParameter({
          name: "query",
          value: searchInput.value,
          push: true
        });
      }

      $.get(searchForm.getAttribute("action"), {
        query: searchInput.value,
        searchOrder
      }, (data) => {

        let div = document.createElement("div");
        div.innerHTML = data;
        const searchHtmlNew = div.querySelector("#search-html");
        searchHtml.innerHTML = searchHtmlNew.innerHTML;
        div = undefined;

        // Initialize All

        showItems(".catalog-items-self .item:not([data-show]), .catalog-subcategories .item:not([data-show])", 0);
        catalogItemHoverInit(".catalog-items-self .item");
        catalogItemHoverColorBgInit(".catalog-items-self .item");
        catalogItemSizeInit(".catalog-items-self .item", catalogGetRow());
        initColorTitleHover();

        preloader.events();

        let timeout = +new Date() - timeCounter < 2250 ? 2250 - (+new Date() - timeCounter) : 50;
        if (searchFirstAfterOpen === false) timeout = 50;
        setTimeout(() => {
          initAButtonHover();
          resizeAButtonHover();
        }, timeout);

        searchFirstAfterOpen = false;
      });

      /* $.ajax({
          type: 'GET',
          url: searchForm.getAttribute("action"),
          data: "query=" + searchInput.value + "&searchOrder=" + searchOrder,
          success: function(data){
                let div = document.createElement("div");
              div.innerHTML = data;
              let searchHtmlNew = div.querySelector("#search-html");
              searchHtml.innerHTML = searchHtmlNew.innerHTML;
              div = undefined;
                // Initialize All
                showItems(".catalog-items-self .item:not([data-show]), .catalog-subcategories .item:not([data-show])", 0);
              catalogItemHoverInit(".catalog-items-self .item");
              catalogItemHoverColorBgInit(".catalog-items-self .item");
              catalogItemSizeInit(".catalog-items-self .item", catalogGetRow());
              initColorTitleHover();
                preloader.events();
                let timeout = (+new Date() - timeCounter) < 2250 ? 2250 - (+new Date() - timeCounter) : 50;
              if(searchFirstAfterOpen === false) timeout = 50;
              setTimeout(function(){
                  initAButtonHover();
                  resizeAButtonHover();
              }.bind(this), timeout);
                searchFirstAfterOpen = false;
            }.bind(this)
      }); */
    };

    const searchStyles = document.createElement("style");
    document.body.appendChild(searchStyles);

    function initSearchStyles() {
      let diameter = parseInt(Math.sqrt(Math.pow((v.viewportHeight[1] - 120) * 2, 2) + Math.pow((v.viewportWidth[1] - 60 - 180) * 2, 2))),
        transformClosed = 'translate(-35px, 95px)',
        transformOpened = `translate(${  -60 + diameter / 2  }px, ${  120 - diameter / 2  }px)`;
      if (v.viewportWidth[1] <= v.properties.tablet) {
        diameter = parseInt(Math.sqrt(Math.pow((v.viewportHeight[1] - 120) * 2, 2) + Math.pow((v.viewportWidth[1] - 45 - 165) * 2, 2)));
      }
      if (v.viewportWidth[1] <= v.properties.tablet) {
        transformClosed = 'translate(-20px, 95px)';
      }
      if (v.viewportWidth[1] <= v.properties.tablet) {
        transformOpened = `translate(${  -45 + diameter / 2  }px, ${  120 - diameter / 2  }px)`;
      }
      searchStyles.innerHTML = `\n        @keyframes searchClose{\n            from{\n                transform: ${  transformOpened  };\n                width: ${  diameter  }px;\n                height: ${  diameter  }px;\n                background: #fbfbfb;\n            }\n            to{\n                transform: ${  transformClosed  };\n                width: 50px;\n                height: 50px;\n                background: #fff;\n            }\n        }\n        @keyframes searchOpen{\n            from{\n                transform: ${  transformClosed  };\n                width: 50px;\n                height: 50px;\n                background: #fff;\n            }\n            to{\n                transform: ${  transformOpened  };\n                width: ${  diameter  }px;\n                height: ${  diameter  }px;\n                background: #fbfbfb;\n            }\n        }\n    `;
      if (v.browser === 'ie' || v.browser === 'edge' || v.browser === 'safari' || v.viewportWidth[1] <= v.properties.tablet) {
        searchStyles.innerHTML = '\n            @keyframes searchClose{\n                from{\n                    width: 100%;\n                    height: 100%;\n                    opacity: 1;\n                    background: #fbfbfb;\n                    transform: none;\n                    border-radius: 0;\n                }\n                99%{\n                    width: 100%;\n                    height: 100%;\n                    opacity: 0;\n                    background: #fff;\n                    transform: none;\n                    border-radius: 0;\n                }\n                100%{\n                    width: 0;\n                    height: 0;\n                    opacity: 0;\n                    background: #fff;\n                    transform: none;\n                    border-radius: 0;\n                }\n            }\n            @keyframes searchOpen{\n                from{\n                    width: 0;\n                    height: 0;\n                    opacity: 0;\n                    background: #fff;\n                    transform: none;\n                    border-radius: 0;\n                }\n                1%{\n                    width: 100%;\n                    height: 100%;\n                    opacity: 0;\n                    background: #fff;\n                    transform: none;\n                    border-radius: 0;\n                }\n                to{\n                    width: 100%;\n                    height: 100%;\n                    opacity: 1;\n                    background: #fbfbfb;\n                    transform: none;\n                    border-radius: 0;\n                }\n            }\n        ';
      }
    }
    v.loadArray.push(initSearchStyles.bind(this));
    v.resizeArray.push(['wh', initSearchStyles.bind(this)]);

    // search init

    if (v.checkPage("search")) {
      if (searchInput.value.length >= 3) {
        searchVInput.classList.add("not-empty");
        if (searchHtml.children.length > 0) {
          if (v.viewportWidth[1] >= 950) {
            searchVInput.classList.add("progress");
            searchInputOuter.classList.add("resize");
            searchVInput.classList.add("show-label");
            searchVInput.classList.add("show-label-opacity");
            // searchHtml.classList.remove("display-none");
            $(searchHtml).stop().fadeIn(500);
          } else {
            searchVInput.classList.add("progress");
            searchInputOuter.classList.add("resize");
            searchVInput.classList.add("show-label");
            searchVInput.classList.add("show-label-opacity");
            $(searchHtml).stop().fadeIn(500);
          }
          v.loadArray.push(() => {
            showItems(".catalog-items-self .item:not([data-show]), .catalog-subcategories .item:not([data-show])", 0);
            catalogItemHoverInit(".catalog-items-self .item");
            catalogItemHoverColorBgInit(".catalog-items-self .item");
            catalogItemSizeInit(".catalog-items-self .item", catalogGetRow());
            initColorTitleHover();
            preloader.events();
          });
        }
      }
      let inputText = document.querySelector(".search-content .input .v-input input[type='text']"),
        inputReset = document.querySelector(".search-content #search-reset");
      if (inputText !== null & inputReset !== null) {
        inputReset.onclick = function () {
          setTimeout(() => {
            inputText.value = '';
          }, 250);
        };
      }
    }





    // A Button Hover

    const aButtonHoverArray = [];

    function initAButtonSubmit() {
      const aButtonSubmit = document.querySelectorAll(".a-button-submit");
      for (let _i43 = 0; _i43 < aButtonSubmit.length; _i43++) {
        if (aButtonSubmit[_i43].getAttribute("data-a-button-submit") !== null) continue;
        const submit = aButtonSubmit[_i43].previousElementSibling;
        if (submit.getAttribute("type") == "submit") {
          aButtonSubmit[_i43].onclick = function (submit, e) {
            e.preventDefault();
            $(submit).click();
          }.bind(this, submit);
          aButtonSubmit[_i43].setAttribute("data-a-button-submit", 'true');
        }
      }
    }

    initAButtonSubmit();

    function initAButtonHover() {
      const aButtonHover = document.querySelectorAll(".a-button-hover");
      for (let _i44 = 0; _i44 < aButtonHover.length; _i44++) {
        if (aButtonHover[_i44].getAttribute("data-a-button-hover") !== null) continue;
        const spanText = aButtonHover[_i44].querySelector("span.text");
        if (spanText !== null) {
          const newSpanText = document.createElement("div");
          newSpanText.classList.add("text");
          newSpanText.classList.add("text-1");
          newSpanText.innerHTML = `<span>${  spanText.innerHTML  }</span>`;
          aButtonHover[_i44].appendChild(newSpanText);
          const spanLine = aButtonHover[_i44].querySelector("span.line");
          if (spanLine !== null) {
            const newSpanLine = document.createElement("div");
            newSpanLine.classList.add("line-1-div");
            newSpanLine.innerHTML = '<span class="line line-1"></span>';
            aButtonHover[_i44].appendChild(newSpanLine);
            // add
            aButtonHover[_i44].setAttribute("data-a-button-hover", 'true');
            aButtonHoverArray.push(aButtonHover[_i44]);
          }
        }
      }
    }

    function resizeAButtonHover() {
      for (let _i45 = 0; _i45 < aButtonHoverArray.length; _i45++) {
        const text1Span = aButtonHoverArray[_i45].querySelector(".text-1 span");
        if (text1Span !== null) {
          text1Span.style.width = `${Math.ceil(aButtonHoverArray[_i45].clientWidth + .5)  }px`;
        }
        const line1Span = aButtonHoverArray[_i45].querySelector(".line-1-div span");
        if (line1Span !== null) {
          line1Span.style.width = `${Math.ceil(aButtonHoverArray[_i45].clientWidth + .5)  }px`;
        }
      }
    }

    v.resizeArray.push(["wh", resizeAButtonHover.bind(this)]);
    initAButtonHover();
    resizeAButtonHover();
    v.loadArray.push(resizeAButtonHover.bind(this));

    window.vFormDisabled = function (disabled, submit) {
      if (disabled === true) {
        submit.nextElementSibling.classList.add("disabled");
      } else {
        submit.nextElementSibling.classList.remove("disabled");
      }
    };


    // Home Page

    if (v.checkPage("home")) {
      const homeShowSlider = function homeShowSlider() {
        document.documentElement.classList.add("show-content-all");
        sliderContent.classList.remove("none-animation");
        setTimeout(slider.nextHover.bind(this), 1500);
        setTimeout(() => {
          loaderBg.classList.add("display-none");
          loaderRight.classList.add("display-none");
          loaderPercent.classList.add("display-none");
          document.documentElement.classList.add("header-buttons-show");
        }, 1000);
        setTimeout(() => {
          document.documentElement.classList.remove("header-buttons-show");
          document.documentElement.classList.add("header-buttons-shown");
        }, 1700);
      };

      // slider

      const setTabletSlider = function setTabletSlider() {
        const num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


        tabletSliderDeny = true;
        setTimeout(() => {
          tabletSliderDeny = false;
        }, 1325);

        const prevSlide = tabletSliderActive;

        tabletSliderOuter.classList.remove("first-start");

        if (num !== null & num !== 'prev') {
          tabletSliderActive = num;
        } else if (num === 'prev') {
          tabletSliderOuter.classList.add("prev-animate");
          tabletSliderActive -= 1;
        } else {
          tabletSliderOuter.classList.remove("prev-animate");
          tabletSliderActive += 1;
        }
        if (tabletSliderActive >= tabletSliderImagesItems.length) {
          tabletSliderActive = 0;
        }
        if (tabletSliderActive < 0) {
          tabletSliderActive = tabletSliderImagesItems.length - 1;
        }

        for (let _i58 = 0; _i58 < tabletSliderImagesItems.length; _i58++) {
          if (_i58 !== tabletSliderActive) {
            tabletSliderImagesItems[_i58].classList.remove("prev");
            tabletSliderImagesItems[_i58].classList.remove("active");
            if (_i58 === prevSlide) {
              tabletSliderImagesItems[_i58].classList.add("prev");
            }
          } else {
            tabletSliderImagesItems[_i58].classList.add("active");
          }
        }

        for (let _i59 = 0; _i59 < tabletSliderContentItems.length; _i59++) {
          if (_i59 !== tabletSliderActive) {
            tabletSliderImagesItems[_i59].classList.remove("prev");
            tabletSliderContentItems[_i59].classList.remove("active");
            if (_i59 === prevSlide) {
              tabletSliderImagesItems[_i59].classList.add("prev");
            }
          } else {
            tabletSliderContentItems[_i59].classList.add("active");
          }
        }
      };

      // loader

      var loaderBg = document.querySelector("#loader-bg"),
        loaderRight = document.querySelector("#loader-right"),
        loaderRightDiv = loaderRight.querySelector("div"),
        loaderPercent = document.querySelector("#loader-percent"),
        loaderPercentDiv = loaderPercent.querySelector("div");
      window.loaderP = 0;

      v.loadArray.push(() => {
        setTimeout(() => {
          document.documentElement.classList.add("loader-right-show");
          $(loaderPercentDiv).prop('Counter', 0).animate({
            Counter: 100
          }, {
            duration: 750,
            easing: 'swing',
            step: function step(now) {
              now = parseInt(Math.ceil(now));
              if (now < 100) {
                if (now == 0) {
                  now = '00';
                } else if (now < 10) {
                  now = `0${  now}`;
                }
                $(this).text(`${now  }%`);
              } else if (window.loaderP !== 1) homeShowSlider();
              window.loaderP = now / 100;
            }
          });
        }, 350);
        setTimeout(() => {
          document.documentElement.classList.add("loader-bg-hide");
        }, 500);
      });

      window.slider = false;
      v.loadArray.push(() => {

        window.slider = v.canvasSlider({
          controlsOnFirst: false,
          before: function before(active, next) {
            sliderContentChange(next);
          },
          after: function after(prev, active) {
            // console.log(arguments)
          }
        });

        const sliderOuter = document.querySelector("#v-canvas-slider");
        sliderOuter.addEventListener("mouseenter", () => {
          if (v.viewportWidth[1] > v.properties.tablet) {
            window.slider.setIntervalFunc();
          }
        });
        sliderOuter.addEventListener("mouseleave", () => {
          window.slider.clearIntervalFunc();
        });

        const scrollDown = sliderOuter.querySelector(".scroll-down");
        scrollDown.onclick = window.slider.next.bind(this);

        const nextButton = sliderOuter.querySelector(".next-button");
        nextButton.onclick = window.slider.next.bind(this);

        window.setSlider = function () {
          const bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

          if (bool === true) {
            if (v.viewportWidth[1] >= 950) {
              window.slider.setKeydown(true);
              window.slider.setSwipe(true);
              window.slider.setWheel(true);
            }
          } else {
            window.slider.setKeydown(false);
            window.slider.setSwipe(false);
            window.slider.setWheel(false);
          }
        };

        v.resizeArray.push(['wh', function () {
          if (v.viewportWidth[1] >= 950) {
            setSlider(true);
          } else {
            setSlider(false);
          }
        }]);

        if (v.viewportWidth[1] >= 950) {
          setSlider(true);
        } else {
          setSlider(false);
        }
      });

      var sliderContent = document.querySelector("#slider-content"),
        sliderContentItems = sliderContent.querySelectorAll(".item"),
        sliderContentFirst = true;
      var sliderContentChange = function sliderContentChange(num) {
        if (sliderContentFirst !== true) {
          sliderContent.classList.remove("first-start");
        }
        for (let _i55 = 0; _i55 < sliderContentItems.length; _i55++) {
          sliderContentItems[_i55].classList.remove("active");
          if (_i55 === num) {
            sliderContentItems[_i55].classList.add("active");
          }
        }
        sliderContentFirst = false;
      };
      sliderContentChange(0);

      // tablet slider

      let homeSliderOuter = document.querySelector("#v-canvas-slider"),
        homeSliderScroll = document.querySelector("#v-canvas-slider .scroll-down"),
        homeSliderImages = document.querySelectorAll("#v-canvas-slider > ul:not(.nav) li img"),
        homeSliderContent = document.querySelector("#slider-content");

      var tabletSliderOuter = document.createElement("div"),
        tabletSliderActive = 0,
        tabletSliderDeny = false;
      tabletSliderOuter.classList.add("tablet-slider-outer");
      tabletSliderOuter.classList.add("first-start");
      tabletSliderOuter.setAttribute("id", "tablet-slider-outer");
      wrap.appendChild(tabletSliderOuter);
      tabletSliderOuter.innerHTML = homeSliderScroll.outerHTML;

      const tabletSliderScrollDown = tabletSliderOuter.querySelector(".scroll-down");
      tabletSliderScrollDown.onclick = setTabletSlider.bind(this, null);

      const tabletSliderImages = document.createElement("div");
      tabletSliderImages.classList.add("images");
      tabletSliderOuter.appendChild(tabletSliderImages);
      var tabletSliderImagesItems = [];
      for (let _i56 = 0; _i56 < homeSliderImages.length; _i56++) {
        const imageItem = document.createElement("div");
        imageItem.classList.add("item");
        imageItem.innerHTML = `<div class="bg-image" style="background-image: url('${  homeSliderImages[_i56].src  }')"></div>`;
        if (_i56 === 0) {
          imageItem.classList.add("active");
        }
        tabletSliderImagesItems.push(imageItem);
        tabletSliderImages.appendChild(imageItem);
      }

      const tabletSliderContent = document.createElement("div");
      tabletSliderContent.classList.add("content-items");
      tabletSliderOuter.appendChild(tabletSliderContent);
      tabletSliderContent.innerHTML = homeSliderContent.innerHTML;
      var tabletSliderContentItems = tabletSliderContent.querySelectorAll(".item");
      for (let _i57 = 0; _i57 < tabletSliderContentItems.length; _i57++) {
        if (_i57 === 0) {
          tabletSliderContentItems[_i57].classList.add("active");
        }
      }

      window.setTabletSlider = setTabletSlider;
      // setTabletSlider(0);

      // Swipe

      let touchYStart = 0,
        swipeK = 35;

      // touchstart
      tabletSliderOuter.addEventListener("touchstart", (e) => {
        // e.preventDefault();
        e.stopPropagation();
        touchYStart = e.targetTouches[0].pageY;
      });

      // touchend
      tabletSliderOuter.addEventListener("touchend", (e) => {
        // e.preventDefault();
        e.stopPropagation();
        if (tabletSliderDeny === false) {
          const touchY = e.changedTouches[0].pageY;
          // y
          if (touchY < touchYStart) {
            if (touchYStart > touchY + swipeK) {
              window.setTabletSlider();
              return false;
            }
          } else if (touchY > touchYStart) {
            if (touchY > touchYStart + swipeK) {
              window.setTabletSlider('prev');
              return false;
            }
          }
        }
      });
    }



    // Item Page

    function addToCart() {
      const id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      const open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      const e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (e !== null) e.preventDefault();
      if (open !== true) {
        window.cart.add(id);
      } else {
        window.cart.add(id, cartOpenClose.bind(this, true));
      }
    }


  })();

  // Color Hover

  const colorTitleHover = [document.querySelector("#color-title-hover-0")];

  function initColorTitleHover() {

    let elements = document.querySelectorAll(".catalog-items-self .item .item-colors .item-color, .v-filter-item-color a"),
      hoverTimeout = 300,
      hoverBool = false,
      hoverElement = null;

    for (let i = 0; i < elements.length; i++) {

      if (elements[i].getAttribute("data-title-hover") !== null) continue;
      elements[i].setAttribute("data-title-hover", "true");

      elements[i].onmouseover = function (e) {

        if (v.viewportWidth[1] <= v.properties.tablet) return;
        if (e.parentNode.classList.contains("disabled")) return;
        hoverBool = true;
        hoverElement = e;
        if (hoverElement.getAttribute("data-title") == null || hoverElement.getAttribute("data-title") == "") return;

        setTimeout(() => {

          const current = 0;

          if (hoverBool === true & hoverElement !== null) {
            if (hoverElement.getAttribute("data-title") == null || hoverElement.getAttribute("data-title") == "") return;
            colorTitleHover[current].innerHTML = hoverElement.getAttribute("data-title");
            colorTitleHover[current].classList.remove("animate");
            const bounding = e.getBoundingClientRect();
            colorTitleHover[current].classList.remove("display-none");
            colorTitleHover[current].style.top = `${bounding.top - colorTitleHover[current].clientHeight - 8  }px`;
            colorTitleHover[current].style.left = `${bounding.left + e.clientWidth / 2 - 2  }px`;
            setTimeout(() => {
              colorTitleHover[current].classList.add("animate");
            }, 25);
          } else {
            colorTitleHover[current].classList.remove("animate");
            setTimeout(() => {
              colorTitleHover[current].classList.add("display-none");
            }, 295);
          }
        }, hoverTimeout);
      }.bind(this, elements[i]);

      elements[i].onmouseleave = function (e) {
        hoverBool = false;
        hoverElement = null;
        colorTitleHover[0].classList.remove("animate");
        setTimeout(() => {
          colorTitleHover[0].classList.add("display-none");
        }, 295);
      }.bind(this, elements[i]);
    }
  }

  initColorTitleHover();




}


// WEBPACK FOOTER //
// app/scripts/components/home-slider.js